<template>
  <section id="project-analysis">
    <div style="display: flex; width: 100%; font-size: 1rem">
      <div style="position: relative">
        <div
          v-if="!showToC"
          style="
            position: absolute;
            top: 1.5rem;
            right: 100%;
            white-space: nowrap;
            -webkit-transform: rotate(270deg);
            -webkit-transform-origin: right top;
            -moz-transform: rotate(270deg);
            -moz-transform-origin: right top;
            -ms-transform: rotate(270deg);
            -ms-transform-origin: right top;
            -o-transform: rotate(270deg);
            -o-transform-origin: right top;
            transform: rotate(270deg);
            transform-origin: right top;
          "
        >
          <button
            class="toc__heading--button"
            style="
              background-color: var(--base-ui-colour);
              border-radius: 0.5em;
              border-width: 1px;
              border-style: solid;
              border-color: var(--outline-light-colour);
              border-image: none;
              width: 100%;
              margin: 0.5rem;
            "
            @click="openToC"
          >
            <VisibleText> Show saved snippets </VisibleText>
          </button>
        </div>
      </div>

      <div style="display: flex; flex-direction: row; width: 100%">
        <!--------------------------------------------
        |
        | Table of Contents
        |
        --------------------------------------------->
        <div id="project-table-of-contents" style="display: flex">
          <div
            v-show="!showToC"
            style="
              border-radius: 0.5em;
              border: 1px solid transparent;
              border-color: var(--outline-light-colour);
              display: flex;
              margin: 0;
              margin-left: -0.5rem;
              width: 2.5%;
              background-color: var(--base-ui-colour);
              position: absolute;

              visibility: hidden;
            "
          >
            <button
              style="
                transform: rotate(-90deg);
                display: flex;
                white-space: nowrap;
                margin: auto;
                background-color: transparent;
                border-color: transparent;
                width: 1em;
                margin-top: 10em;
                height: max-content;
              "
              @click="openToC()"
            >
              open table of contents
            </button>
          </div>
          <div
            v-show="showToC"
            style="
              border-radius: 0.5em;
              border: 1px solid transparent;
              border-color: var(--outline-light-colour);
              display: flex;
              width: 100%;
              max-width: 15rem;
              padding-right: 1rem;
              background-color: var(--base-ui-colour);
              height: max-content;
              z-index: 20;
              margin-top: 1rem;
              padding: 1rem;
            "
          >
            <div
              class="project-analysis__toc__heading--content"
              style="
                padding: 2em 0 0 2em;
                line-height: 1.5em;
                display: flex;
                flex-direction: column;
              "
              v-if="!this.project.collection_id"
            >
              <VisibleText style="display: flex">
                Empty report: run an analysis and click "save to report"
              </VisibleText>
              <button
                @click="closeToC"
                style="
                  display: flex;
                  color: var(--primary);
                  border: none;
                  background-color: white;
                  justify-content: flex-end;
                  margin-right: 1em;
                "
              >
                <VisibleText>hide</VisibleText>
              </button>
            </div>
            <DocManager
              v-if="this.project.collection_id"
              ref="DocManagerRef"
              :collectionId="this.project.collection_id"
              v-model="docs"
              :templates="templates"
              class="custom-report__docmanager"
              @toggleToC="closeToC"
              @deleteTheseNodes="deleteTheseNodes($event)"
            />
          </div>
        </div>
        <div
          class="project-analysis__analysis"
          id="project-analysis__analysis"
          style="
            display: flex;
            background-color: transparent;
            flex-direction: column;
            align-items: flex-start;
          "
        >
          <!--------------------------------------------
          |
          | Project Analysis Types (Tabs)
          |
          --------------------------------------------->
          <div
            id="project-analysis-tabs"
            style="display: flex; flex-direction: row; margin: 1rem 2rem"
          >
            <nav
              style="
                margin: 0 0 0.5rem 0;
                background-color: var(--base-ui-colour);
                border-radius: 0.5em;
                border: 1px solid transparent;
                border-color: var(--outline-light-colour);
                width: auto;
              "
              aria-label="project analysis"
              :aria-hidden="modalOpen"
              :inert="modalOpen"
            >
              <ul
                class="project-analysis__analysis__tabs-list"
                style="margin: 1rem 2rem; padding: 0"
              >
                <li
                  v-for="item in reformatedTabs"
                  :key="item.name"
                  :class="[
                    'project-analysis__tabs-list-item',
                    {
                      'project-analysis__tabs-list-item-active': activeTab === item.name,
                    },
                  ]"
                >
                  <router-link
                    :to="{ name: `projectAnalysis${item.name}` }"
                    class="project-analysis__tabs-list-item-btn"
                  >
                    <div v-if="item.name === 'Text'">
                      <img
                        style="width: 1.25em"
                        src="/assets/sentiment_chart.png"
                        alt="find themes and sentiment in text"
                      />
                    </div>
                    <div v-if="item.name === 'Drivers'">
                      <img
                        style="width: 1.25em"
                        src="/assets/matrix_chart.png"
                        alt="predict top drivers of key scores"
                      />
                    </div>
                    <div v-if="item.name === 'Outliers'">
                      <img
                        style="width: 1.25em"
                        src="/assets/outliers_analysis.png"
                        alt="find outliers which may be red flags"
                      />
                    </div>
                    <div v-if="item.name === 'Performance'">
                      <img
                        style="width: 1.25em"
                        src="/assets/performance_chart.png"
                        alt="create your own performance charts"
                      />
                    </div>
                    <div v-if="item.name === 'Benchmarking'">
                      <img
                        style="width: 1.25em"
                        src="/assets/benchmarking_chart.png"
                        alt="benchmark your dataset to peers"
                      />
                    </div>
                    <div v-if="item.name === 'Sentiment crosstabs'">
                      <img
                        style="width: 1.25em"
                        src="/assets/tools.png"
                        alt="additional report tools"
                      />
                    </div>
                    <div v-if="item.name === 'Tools'">
                      <img
                        style="width: 1.25em"
                        src="/assets/tools.png"
                        alt="additional report tools"
                      />
                    </div>
                    <div v-if="item.name === 'Auto'">
                      <img
                        style="width: 1.25em"
                        src="/assets/wand.png"
                        alt="additional report tools"
                      />
                    </div>
                    <VisibleText
                      class="project-analysis__tabs-list-item-text"
                      style="font-size: 1rem"
                    >
                      {{ item.name }}
                    </VisibleText>
                  </router-link>
                </li>
              </ul>
            </nav>
            <div style="display: flex" v-if="hasMissingAnalysis">
              <div
                v-if="tabMode == 'showAvailable'"
                style="margin: auto; padding: 0 0.5em 0.5em 0.5em"
              >
                <button
                  @click="changeTabMode('showAll')"
                  style="background-color: transparent; border: none"
                >
                  <VisibleText>Show all analysis</VisibleText>
                </button>
              </div>
              <div v-if="tabMode == 'showAll'" style="margin: auto; padding: 0 0.5em 0.5em 0.5em">
                <button
                  @click="changeTabMode('showAvailable')"
                  style="background-color: transparent; border: none"
                >
                  <VisibleText>Show only available analysis</VisibleText>
                </button>
              </div>
            </div>
            <div v-if="!hasMissingAnalysis" style="margin-top: 1rem"></div>
          </div>
          <div
            class="project-analysis__main"
            style="
              border-radius: 0.5em;
              border: 1px solid transparent;
              border-color: var(--outline-light-colour);
              display: flex;
              flex-direction: column;
              background-color: var(--base-ui-colour);
              padding: 2rem;
              margin: auto;
              width: 93%;
            "
          >
            <!--------------------------------------------
            |
            | Project Analysis Headings
            |
            --------------------------------------------->
            <div id="project-analysis-headings">
              <h2 class="sr-only">
                <div v-if="activeTab == 'Text'">
                  <VisibleText>Text Analysis</VisibleText>
                </div>
                <div v-if="activeTab == 'Drivers'">
                  <VisibleText>Drivers Analysis</VisibleText>
                </div>
                <div v-if="activeTab == 'Outliers'">
                  <VisibleText>Find outliers by groups</VisibleText>
                </div>
                <div v-if="activeTab == 'Benchmarking'">
                  <VisibleText>Benchmark your data to peers</VisibleText>
                </div>
                <div v-if="activeTab == 'Performance'">
                  <VisibleText>Performance analysis</VisibleText>
                </div>
                <div v-if="activeTab == 'Tools'">
                  <VisibleText>Report tools</VisibleText>
                </div>
                <div v-if="activeTab == 'Auto'">
                  <VisibleText>Auto-analysis</VisibleText>
                </div>
              </h2>
              <div class="project-analysis__header">
                <h2
                  class="project-analysis__header-title"
                  style="font-size: 1.8rem; margin-right: 1.5rem"
                >
                  <div v-if="activeTab == 'Text'">
                    <VisibleText>Text analysis</VisibleText>
                  </div>
                  <div v-if="activeTab == 'Drivers'">
                    <VisibleText>Drivers analysis</VisibleText>
                  </div>
                  <div v-if="activeTab == 'Outliers'">
                    <VisibleText>Find outliers by groups</VisibleText>
                  </div>
                  <div v-if="activeTab == 'Benchmarking'">
                    <VisibleText>Benchmark your data to peers</VisibleText>
                  </div>
                  <div v-if="activeTab == 'Performance'">
                    <VisibleText>Performance analysis</VisibleText>
                  </div>
                  <div v-if="activeTab == 'Tools'">
                    <VisibleText>Report tools</VisibleText>
                  </div>
                  <div v-if="activeTab == 'Auto'">
                    <VisibleText>Auto-analysis</VisibleText>
                  </div>
                </h2>
                <!--------------------------------------------
                |
                | Project Analysis Tips Banner
                |
                --------------------------------------------->
                <div v-if="activeTab == 'Text'">
                  <div
                    class="message__block message__block--information"
                    style="
                      display: flex;
                      flex-direction: column;
                      margin: auto auto auto 0;
                      width: auto;
                    "
                  >
                    <div style="display: flex; flex-direction: column">
                      <div style="display: flex; flex-direction: row; margin: auto">
                        <VisibleText style="font-weight: 800"> Learn more</VisibleText>
                      </div>
                      <div style="display: flex; flex-direction: row; margin: auto">
                        <button
                          @click="openVideo('text-analysis')"
                          style="
                            background: none;
                            color: var(--secondary);
                            border: none;
                            padding: 0;
                            font: inherit;
                            text-decoration: underline;
                            margin: 0.5rem;
                          "
                        >
                          <SvgIconDecorative icon="video" />
                          <VisibleText>Watch</VisibleText>
                        </button>
                        <a
                          href="javascript:void(0)"
                          style="margin: 0.5rem"
                          @click="
                            ($emit('user-guide-expanded'),
                            $emit('open-article', 'ThematicAnalysis'))
                          "
                        >
                          <SvgIconDecorative icon="information" />Tutorial
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="activeTab == 'Drivers'">
                  <div
                    class="message__block message__block--information"
                    style="
                      display: flex;
                      flex-direction: column;
                      margin: auto auto auto 0;
                      width: auto;
                    "
                  >
                    <div style="display: flex; flex-direction: column">
                      <div style="display: flex; flex-direction: row; margin: auto">
                        <VisibleText style="font-weight: 800"> Learn more</VisibleText>
                      </div>
                      <div style="display: flex; flex-direction: row; margin: auto">
                        <button
                          @click="openVideo('regression')"
                          style="
                            background: none;
                            color: var(--secondary);
                            border: none;
                            padding: 0;
                            font: inherit;
                            text-decoration: underline;
                            margin: 0.5rem;
                          "
                        >
                          <SvgIconDecorative icon="video" />
                          <VisibleText>Watch</VisibleText>
                        </button>
                        <a
                          href="javascript:void(0)"
                          style="margin: 0.5rem"
                          @click="
                            ($emit('user-guide-expanded'), $emit('open-article', 'DriversAnalysis'))
                          "
                        >
                          <SvgIconDecorative icon="information" />Tutorial
                        </a>
                        <a
                          href="https://www.linkedin.com/pulse/cx-driver-analysis-turning-statistics-visual-road-map-edward-murphy"
                          target="_blank"
                          rel="noopener noreferrer"
                          style="margin: 0.5rem"
                        >
                          <SvgIconDecorative icon="externalLink" />
                          Read more
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="activeTab == 'Outliers'">
                  <div
                    class="message__block message__block--information"
                    style="
                      display: flex;
                      flex-direction: column;
                      margin: auto auto auto 0;
                      width: auto;
                    "
                  >
                    <div style="display: flex; flex-direction: column">
                      <div style="display: flex; flex-direction: row; margin: auto">
                        <VisibleText style="font-weight: 800"> Learn more</VisibleText>
                      </div>
                      <div style="display: flex; flex-direction: row; margin: auto">
                        <a
                          href="javascript:void(0)"
                          style="margin: 0.5rem"
                          @click="
                            ($emit('user-guide-expanded'),
                            $emit('open-article', 'OutliersAnalysis'))
                          "
                        >
                          <SvgIconDecorative icon="information" />Tutorial
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="activeTab == 'Benchmarking'">
                  <div
                    class="message__block message__block--information"
                    style="
                      display: flex;
                      flex-direction: column;
                      margin: auto auto auto 0;
                      width: auto;
                    "
                  >
                    <div style="display: flex; flex-direction: column">
                      <div style="display: flex; flex-direction: row; margin: auto">
                        <VisibleText style="font-weight: 800"> Learn more</VisibleText>
                      </div>
                      <div style="display: flex; flex-direction: row; margin: auto">
                        <a
                          href="javascript:void(0)"
                          style="margin: 0.5rem"
                          @click="
                            ($emit('user-guide-expanded'),
                            $emit('open-article', 'BenchmarkingAnalysis'))
                          "
                        >
                          <SvgIconDecorative icon="information" />Tutorial
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="activeTab == 'Performance'"></div>
              </div>
            </div>
            <!--------------------------------------------
            |
            | Project Analysis Descriptions (by type)
            |
            --------------------------------------------->
            <div id="project-analysis-descriptions">
              <div v-if="activeTab == 'Text'">
                <p class="benchmarking__desc">
                  <VisibleText
                    >Find out how often people talk about specific topics! Our easy-to-use text
                    analysis tool helps you discover what percentage of respondents mention key
                    ideas, making it simple to understand trends.</VisibleText
                  >

                  <VisibleText
                    >Why use ResearchAI Text analysis? Because we help you create accurate
                    percentages of the topics discussed. Not a vague summary.</VisibleText
                  >

                  <VisibleText>
                    Add a new text analysis, then press "Generate themes" to get
                    started.</VisibleText
                  >
                </p>
              </div>
              <div v-if="activeTab == 'Drivers'">
                <p class="benchmarking__desc">
                  <VisibleText
                    >Drivers analysis is a technique used to make predictions about any scale,
                    category or numeric data. This is done with common statistical techniques like
                    <a
                      href="https://en.wikipedia.org/wiki/Regression_analysis"
                      target="_blank"
                      rel="noopener noreferrer"
                      >regression analysis</a
                    >.
                  </VisibleText>
                  <VisibleText
                    >By finding what questions predict an outcome like "overall satisfaction" or
                    "willingness to recommend", organizations can prioritize where to focus
                    energies.
                  </VisibleText>
                </p>
              </div>
              <div v-if="activeTab == 'Outliers'">
                <p class="drivers__desc" :inert="modalOpen" :aria-hidden="modalOpen">
                  <VisibleText>
                    This analysis lets you find outliers across rows of data by finding groups (or
                    categories) or rows that have a high
                  </VisibleText>
                  <Tooltip
                    class="drivers__info"
                    :text-visible="isInfoTooltipOpen"
                    @close="isInfoTooltipOpen = false"
                  >
                    <template #title>
                      <button class="drivers__regression-btn" @click="isInfoTooltipOpen = true">
                        <VisibleText>z-scores</VisibleText>
                        <SvgIconDecorative
                          icon="info"
                          class="drivers__regression-btn-icon"
                          title="details"
                        />
                      </button>
                    </template>
                    <VisibleText>
                      Z-scores are standardized measures for how much of an outlier a datapoint is
                      compared to its peers. Most data are between -2 or 2 standard deviations
                      (z-scores) away from the mean. Scores above or below this become considered
                      outliers.
                    </VisibleText>
                    <ul>
                      <li>
                        <VisibleText> Greater or less than 2: Somewhat an outlier </VisibleText>
                      </li>
                      <li>
                        <VisibleText>Greater or less than 3: An outlier</VisibleText>
                      </li>
                      <li>
                        <VisibleText>Greater or less than 4: A strong outlier</VisibleText>
                      </li>
                      <li>
                        <VisibleText> Greater or less than 5: An extreme outlier </VisibleText>
                      </li>
                    </ul>
                  </Tooltip>
                  <VisibleText>
                    which signals these groups may be considerably above or below the average
                    scores. Identifying these can be helpful for removing extreme results, or for
                    finding specific groups that may be in need of attention. Below you can explore
                    and 'save' the most interesting outliers.
                  </VisibleText>
                </p>
                <p>
                  <VisibleText>
                    Note that this requires both scale questions (such as 5-point scales) as well as
                    categorical questions. As this tool looks for those with high or low scale
                    performance across different categories as groups.
                  </VisibleText>
                </p>
              </div>
              <div v-if="activeTab == 'Benchmarking'">
                <p class="benchmarking__desc">
                  <VisibleText
                    >How does your organization compare to your peers? Benchmarks summarize averages
                    or outliers based on segments of your dataset. For each question in your dataset
                    that matches with our global database, we calculate the average and compare your
                    score to each group. This indicates how organizations are performing in that
                    group of service delivery.
                  </VisibleText>
                </p>
              </div>
              <div v-if="activeTab == 'Performance'">
                <p class="performance__desc" :inert="modalOpen" :aria-hidden="modalOpen">
                  <VisibleText
                    >Select a range of scale questions to chart how each question performs.
                  </VisibleText>
                </p>
              </div>
              <div v-if="activeTab == 'Tools'">
                <p class="performance__desc">
                  <VisibleText>You can add custom visualizations to your reports. </VisibleText>
                </p>
              </div>
              <div v-if="activeTab == 'Auto'">
                <p class="performance__desc">
                  <VisibleText>We support API integration. </VisibleText>
                </p>
              </div>
            </div>
            <!--------------------------------------------
            |
            | Project analysis "Add new" buttons
            |
            --------------------------------------------->
            <div
              id="project-analysis-new"
              style="display: flex"
              :style="sortedItems.length ? 'justify-content: flex-end' : 'justify-content: center'"
            >
              <div v-if="activeTab == 'Text'" style="display: flex; flex-direction: column">
                <div style="display: flex; margin: auto">
                  <VisibleText>Add new text analysis</VisibleText>
                </div>
                <div style="display: flex; justify-content: flex-end" v-if="hasTextQuestions">
                  <button
                    class="project-analysis__header-add-btn"
                    @click="addNewTextAnalysis"
                    :disabled="propReadOnly"
                    style="margin: 1rem; height: 2rem"
                  >
                    <VisibleText>Select text question</VisibleText>
                  </button>
                  <button
                    class="project-analysis__header-add-btn-secondary"
                    style="margin: 1rem; border: 1px solid var(--secondary); height: 2rem"
                    :disabled="propReadOnly"
                    @click="autoSuggestedTextAnalysis()"
                  >
                    <VisibleText>Let us suggest a text question</VisibleText>
                  </button>
                </div>
              </div>
              <div v-if="activeTab == 'Drivers'" style="display: flex; flex-direction: column">
                <div style="display: flex; margin: auto">
                  <VisibleText>Add new drivers analysis</VisibleText>
                </div>
                <div style="display: flex; justify-content: flex-end">
                  <Spinner
                    :is-loading="findingSuggestedDriversVariables"
                    message="Searching for suggested analysis"
                    complete-message=""
                  />
                  <button
                    style="margin: 1rem"
                    class="project-analysis__header-add-btn"
                    @click="onClickAddNewDrivers"
                    :disabled="propReadOnly"
                  >
                    <VisibleText>Select question to predict and its predictors</VisibleText>
                  </button>
                  <button
                    class="project-analysis__header-add-btn-secondary"
                    style="margin: 1rem; border: 1px solid var(--secondary); height: 2rem"
                    v-if="this.hasScaleQuestions"
                    :disabled="propReadOnly"
                    @click="findSuggestedDriversVariables()"
                  >
                    <VisibleText>Let us suggest analysis</VisibleText>
                  </button>
                </div>
              </div>
              <div v-if="activeTab == 'Outliers'" style="display: flex; flex-direction: column">
                <div style="display: flex; margin: auto">
                  <VisibleText>Add new outliers analysis</VisibleText>
                </div>
                <div
                  style="display: flex; justify-content: flex-end; margin-left: auto"
                  v-if="hasScaleQuestions"
                >
                  <Spinner
                    :is-loading="findingSuggestedOutliersVariables"
                    message="Searching for suggested analysis"
                    complete-message=""
                  />
                  <button
                    class="project-analysis__header-add-btn"
                    @click="addNewOutliersAnalysis"
                    :disabled="propReadOnly"
                    style="margin: 1rem"
                  >
                    <VisibleText>Select scale questions to find outliers</VisibleText>
                  </button>
                  <button
                    class="project-analysis__header-add-btn-secondary"
                    style="margin: 1rem; border: 1px solid var(--secondary); height: 2rem"
                    :disabled="propReadOnly"
                    @click="findSuggestedOutliersVariables()"
                  >
                    <VisibleText>Let us suggest analysis</VisibleText>
                  </button>
                </div>
              </div>
              <div v-if="activeTab == 'Benchmarking'" style="display: flex; flex-direction: column">
                <BenchmarkingMessages
                  :status-benchmarks-pending-approval="statusBenchmarksPendingApproval"
                  :status-benchmarks-not-available="statusBenchmarksNotAvailable"
                  :status-org-not-verified="statusOrgNotVerified"
                  :num-not-approved="numNotApprovedBenchmarks"
                  :num-total="numTotalBenchmarks"
                />
                <div style="display: flex; margin: auto">
                  <VisibleText>Add new benchmarking analysis</VisibleText>
                </div>
                <div style="display: flex; justify-content: flex-end">
                  <Spinner
                    :is-loading="findingSuggestedBenchmarkingVariables"
                    message="Searching for suggested analysis"
                    complete-message=""
                  />
                  <button
                    class="project-analysis__header-add-btn"
                    v-if="!statusBenchmarksNotAvailable"
                    :disabled="propReadOnly"
                    @click="addBenchmarkingAnalysis"
                    style="margin: 1rem"
                  >
                    <VisibleText>Select questions to benchmark</VisibleText>
                  </button>
                  <button
                    class="project-analysis__header-add-btn-secondary"
                    style="margin: 1rem; border: 1px solid var(--secondary); height: 2rem"
                    v-if="!statusBenchmarksNotAvailable"
                    :disabled="propReadOnly"
                    @click="addAutoBenchmarkingAnalysis"
                  >
                    <VisibleText>Let us suggest analysis</VisibleText>
                  </button>
                </div>
              </div>
              <div v-if="activeTab == 'Performance'" style="display: flex; flex-direction: column">
                <div style="display: flex; margin: auto">
                  <VisibleText>Add new performance analysis (horizontal chart)</VisibleText>
                </div>
                <div v-if="hasScaleQuestions" style="display: flex; justify-content: flex-end">
                  <Spinner
                    :is-loading="findingSuggestedPerformanceVariables"
                    message="Searching for suggested analysis"
                    complete-message=""
                  />
                  <button
                    class="project-analysis__header-add-btn"
                    @click="showCreatePerformanceModal"
                    :disabled="!performanceQuestions.length || propReadOnly"
                    style="margin: 1rem"
                  >
                    <VisibleText>Select questions to place in a chart</VisibleText>
                  </button>
                  <button
                    class="project-analysis__header-add-btn-secondary"
                    style="margin: 1rem; border: 1px solid var(--secondary); height: 2rem"
                    :disabled="propReadOnly"
                    @click="findSuggestedPerformanceVariables()"
                  >
                    <VisibleText>Let us suggest analysis</VisibleText>
                  </button>
                </div>
              </div>
            </div>
            <!--------------------------------------------
            |
            | Project analysis sorting
            |
            --------------------------------------------->
            <div id="project-analysis-sort">
              <SortProjects
                :sortBy="sortBy"
                @toggleSort="toggleSort"
                v-if="sortedItems.length > 1"
              />

              <div v-if="activeTab == 'Text'"></div>
              <div v-if="activeTab == 'Drivers'"></div>
              <div v-if="activeTab == 'Outliers'"></div>
              <div v-if="activeTab == 'Benchmarking'"></div>
              <div v-if="activeTab == 'Performance'"></div>
              <div v-if="activeTab == 'Tools'"></div>
              <div v-if="activeTab == 'Auto'"></div>
            </div>
            <!--------------------------------------------
            |
            | Project Analysis Items (loop)
            |
            --------------------------------------------->
            <div v-for="(item, index) in sortedItems" :key="item.uuid" style="position: relative">
              <div style="display: flex; flex-direction: row; margin: 1rem auto">
                <!--------------------------------------------
                |
                | Project Analysis input selection box
                |
                --------------------------------------------->
                <input
                  type="checkbox"
                  class="datasets__table-checkbox"
                  name="analysis-checkbox"
                  :id="'analysis-checkbox-' + item.uuid"
                  @click="addToShowAnalysisCheckOptions(item)"
                  style="
                    width: 1.3rem;
                    height: 1.3rem;
                    cursor: pointer;
                    display: flex;
                    margin: 1rem 1rem;
                    padding: 0.5rem;
                  "
                  v-model="selectedBoxes[index]"
                />
                <!--------------------------------------------
                |
                | Project Analysis main options
                |
                --------------------------------------------->
                <div
                  style="
                    z-index: 10;
                    background-color: white;
                    border-top: 0;
                    border-radius: 0 0 4px 4px;
                    color: var(--base-colour);
                    position: absolute;
                    margin-top: 2rem;
                    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
                    border: 1px solid var(--outline-colour);
                    border-radius: 8px;
                    margin-left: 2rem;
                    width: 13rem;
                  "
                  v-if="
                    showAnalysisCheckOptions.length &&
                    showAnalysisCheckOptions[showAnalysisCheckOptions.length - 1].uuid == item.uuid
                  "
                >
                  <div style="margin-left: 0.5rem">
                    <VisibleText> {{ checkedAnalysis.length }} analysis selected</VisibleText>
                  </div>
                  <div class="theme-options-btn" @click="onClickOpen">
                    <SvgIconDecorative icon="search" />
                    <VisibleText>Open</VisibleText>
                  </div>
                  <div
                    @click="onClickMoreOptions"
                    class="theme-options-btn"
                    :style="propReadOnly ? 'cursor: not-allowed' : ''"
                    v-if="checkedAnalysis.length == 1 && hasOptions"
                  >
                    <SvgIconDecorative icon="gear" />
                    <VisibleText>Options</VisibleText>
                  </div>

                  <div
                    @click="onClickRename"
                    class="theme-options-btn"
                    :style="propReadOnly ? 'cursor: not-allowed' : ''"
                    v-if="checkedAnalysis.length == 1"
                  >
                    <SvgIconDecorative icon="edit" />
                    <VisibleText>Rename</VisibleText>
                  </div>

                  <div
                    @click="onClickDuplicate"
                    class="theme-options-btn"
                    :style="propReadOnly ? 'cursor: not-allowed' : 'cursor:pointer'"
                    v-if="checkedAnalysis.length == 1"
                  >
                    <SvgIconDecorative icon="duplicate" />
                    <VisibleText>Duplicate</VisibleText>
                  </div>
                  <div
                    @click="onClickSave(index)"
                    class="theme-options-btn"
                    :style="propReadOnly ? 'cursor: not-allowed' : 'cursor:pointer'"
                    v-if="checkedAnalysis.length == 1"
                  >
                    <SvgIconDecorative icon="copy" />
                    <VisibleText>Save to report</VisibleText>
                  </div>
                  <div
                    @click="onClickDelete"
                    class="theme-options-btn"
                    :style="propReadOnly ? 'cursor: not-allowed' : ''"
                  >
                    <SvgIconDecorative icon="deleteIcon" />
                    <VisibleText>Delete</VisibleText>
                  </div>
                </div>
                <!--------------------------------------------
                |
                | Project Analysis extra options
                |
                --------------------------------------------->
                <div
                  v-if="showExtraOptions.includes(item.uuid)"
                  style="
                    z-index: 10;
                    background-color: white;
                    border-top: 0;
                    border-radius: 0 0 4px 4px;
                    color: var(--base-colour);
                    position: absolute;
                    margin-top: 4rem;
                    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
                    border: 1px solid var(--outline-colour);
                    border-radius: 8px;
                    margin-left: -1rem;
                    width: 40rem;
                    padding: 1rem;
                  "
                >
                  <div style="display: flex; flex-direction: row">
                    <div v-if="activeTab == 'Text'" style="width: 100%">
                      <VisibleText style="font-weight: 800">
                        Settings for this text analysis
                      </VisibleText>
                      <div
                        style="display: flex; flex-direction: column; width: 100%"
                        class="message__block message__block--information"
                        v-if="Object.keys(selectedTextQuestion).length"
                      >
                        <VisibleText
                          >Your dataset needs AI activated for advanced features.</VisibleText
                        >
                        <div style="display: flex; flex-direction: row">
                          <div
                            class="project-analysis-item__header-wrapper-btn"
                            style="display: flex; font-weight: 200"
                          >
                            <div v-if="!textAIStatus">
                              <button
                                class="btn-secondary"
                                style=""
                                @click="preprocessAI"
                                v-if="!isDatasetReadOnly"
                              >
                                <SvgIconDecorative icon="information" style="margin: auto" />
                                <VisibleText
                                  style="color: var(--base-colour); text-decoration: underline"
                                  >Click here to enable AI text analysis</VisibleText
                                >
                              </button>
                            </div>
                            <div style="margin: auto" v-if="textAIStatus == 'complete'">
                              <SvgIconDecorative icon="success" />
                              <VisibleText>AI text analysis enabled</VisibleText>
                            </div>
                            <div style="margin-left: 1rem" v-if="textAIStatus == 'processing'">
                              <div
                                class="also-found__loading-spinner spinner"
                                style="width: 1rem; height: 1rem; margin-right: 1rem"
                              ></div>
                              <VisibleText style="margin: auto; height: 2rem"
                                >Processing AI text analysis...</VisibleText
                              >
                            </div>
                            <button
                              style="
                                background-color: transparent;
                                font-family: Core-Sans;
                                border-color: transparent;
                                color: var(--primary);
                                margin-bottom: 0.1rem;
                                margin-left: 0.5rem;
                              "
                              @click="showTextAIInfo = !showTextAIInfo"
                            >
                              <strong>Learn more</strong>
                            </button>
                            <TextAIMiniGuide
                              @closingGuide="showTextAIInfo = false"
                              :showInfo="showTextAIInfo"
                              :avoidLeftOffset="true"
                            >
                            </TextAIMiniGuide>
                            <div
                              v-if="
                                selectedTextQuestion.added_count &&
                                selectedTextQuestion.added_all_responses == false
                              "
                              style="padding-left: 0.5rem"
                            >
                              <VisibleText
                                >Your text is too large. Our current version is optimized for
                                5,000,000 characters. Only &nbsp;</VisibleText
                              >
                              <span>{{ selectedTextQuestion.added_count }}</span>
                              <VisibleText>&nbsp;responses were generated.</VisibleText>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="activeTab == 'Drivers'">
                      <VisibleText style="font-weight: 800">
                        Settings for this drivers analysis
                      </VisibleText>
                    </div>
                    <div v-if="activeTab == 'Performance'">
                      <VisibleText style="font-weight: 800">
                        Settings for this performance analysis
                      </VisibleText>
                    </div>
                    <div v-if="activeTab == 'Benchmarking'">
                      <VisibleText style="font-weight: 800">
                        Settings for this benchmarking analysis
                      </VisibleText>
                    </div>
                    <div v-if="activeTab == 'Outliers'">
                      <VisibleText style="font-weight: 800">
                        Settings for this outliers analysis
                      </VisibleText>
                    </div>
                    <div style="margin-left: auto">
                      <ButtonIconOnly
                        icon="remove"
                        class="modal-close-btn"
                        @click-handler="showExtraOptions = []"
                      >
                        <VisibleText>close</VisibleText>
                      </ButtonIconOnly>
                    </div>
                  </div>
                  <div v-if="Object.keys(FilterParams).length">
                    <FilterPills
                      :filterParamFromSelectedQuestions="FilterParams"
                      @clearFilters="clearFilters"
                    >
                    </FilterPills>
                  </div>
                  <div v-if="activeTab == 'Text'">
                    <div
                      style="margin: auto; display: flex; flex-direction: row"
                      v-if="textAIStatus == 'complete'"
                    >
                      <input
                        type="checkbox"
                        class="datasets__table-checkbox"
                        name="analysis-checkbox"
                        id="hide-sentiments"
                        style="
                          width: 1.3rem;
                          height: 1.3rem;
                          cursor: pointer;
                          display: flex;
                          margin: 1rem 1rem;
                        "
                        v-model="selectedTextQuestionIncludesSentiment"
                        @click="changeSentimentMode()"
                      />
                      <VisibleText style="margin-top: auto; margin-bottom: auto"
                        ><strong>Include sentiments in themes: </strong> Enable sentiments and show
                        sentiments by theme.</VisibleText
                      >
                    </div>
                    <div
                      style="margin: auto; display: flex; flex-direction: row"
                      v-if="textAIStatus == 'complete'"
                    >
                      <input
                        type="checkbox"
                        class="datasets__table-checkbox"
                        name="analysis-checkbox"
                        id="hide-smart-search"
                        style="
                          width: 1.7rem;
                          height: 1.3rem;
                          cursor: pointer;
                          display: flex;
                          margin: 1rem 1rem;
                        "
                        v-model="selectedTextQuestionIncludesSmartCoverage"
                        @click="changeSmartCoverage()"
                      />
                      <VisibleText style="margin-top: auto; margin-bottom: auto"
                        ><strong>Force themes to smart match:</strong> Keep word order when matching
                        but find across tenses, gender, etc.
                        <span
                          @click="showLemmasInfo = !showLemmasInfo"
                          style="text-decoration: underline; cursor: pointer"
                          >Learn more</span
                        ></VisibleText
                      >
                      <LemmasMiniGuide
                        style="transform: translateY(0); max-width: 35rem"
                        @closingGuide="showLemmasInfo = false"
                        :showLemmasInfo="showLemmasInfo"
                      ></LemmasMiniGuide>
                    </div>
                  </div>
                  <div v-if="activeTab == 'Drivers'">
                    <div style="padding: 0.5rem; margin: auto; display: flex; flex-direction: row">
                      <input
                        type="number"
                        v-model="selectedDriversFilterTop"
                        @change="updateSelectedDriversFilterTop"
                        style="margin-top: auto; margin-bottom: auto; display: flex; width: 25%"
                      />
                      <VisibleText style="margin-top: auto; margin-bottom: auto; margin-left: 2rem"
                        >Select number of drivers to show</VisibleText
                      >
                    </div>
                    <div style="padding: 0.5rem; margin: auto; display: flex; flex-direction: row">
                      <select
                        class="select"
                        id="drivers-model"
                        style="font-size: 1em; width: 30%"
                        v-model="selectedDriversModel"
                        @change="updateSelectedDriverModel()"
                        :disabled="propReadOnly"
                      >
                        <option
                          v-for="(driverModel, driversIndex) in selectedDriversViableModels"
                          :key="driversIndex"
                        >
                          {{ driverModel }}
                        </option>
                      </select>
                      <VisibleText style="margin-top: auto; margin-bottom: auto; margin-left: 2rem"
                        >Select prediction model</VisibleText
                      >
                    </div>
                  </div>
                  <div v-if="activeTab == 'Benchmarking'">
                    <div style="padding: 0.5rem; margin: auto; display: flex; flex-direction: row">
                      <input
                        style="cursor: pointer; padding: 0; margin: 0; font-size: 0.9rem"
                        ref="suggested-date"
                        type="date"
                        id="benchmarking-remove-older"
                        v-model="selectedBenchmarksFilterByDate"
                        @change="updateSelectedBenchmarksFilterByDate()"
                      />
                      <VisibleText style="margin-top: auto; margin-bottom: auto; margin-left: 1rem"
                        ><strong>Remove older than: </strong> Drop benchmarks that are older than
                        this date.</VisibleText
                      >
                    </div>
                  </div>
                  <div v-if="activeTab == 'Performance'">
                    <div
                      style="
                        padding: 0.5rem;
                        margin: auto;
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                      "
                    >
                      <div style="display: flex; margin-right: 1rem">
                        <select
                          class="select"
                          id="performance-sort-by"
                          style="font-size: 1em"
                          v-model="selectedPerformanceSort"
                          :disabled="propReadOnly"
                          @change="updateSelectedPerformanceSort()"
                        >
                          <option
                            v-for="(
                              performanceSortOption, performanceIndex
                            ) in performanceSortOptions"
                            :key="performanceIndex"
                          >
                            {{ performanceSortOption }}
                          </option>
                        </select>
                      </div>

                      <VisibleText style="margin-top: auto; margin-bottom: auto; margin-left: 1rem"
                        ><strong>Sort by:</strong> Modify the order of the rows in the
                        chart.</VisibleText
                      >
                    </div>
                    <!-- <div>
                      <strong> <VisibleText>Requires scale data</VisibleText>: </strong>
                    </div> -->
                    <div
                      style="
                        padding: 0.5rem;
                        margin: auto;
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                      "
                    >
                      <div style="display: flex">
                        <select
                          class="select"
                          id="performance-sort-by"
                          style="font-size: 1em"
                          v-model="selectedPerformanceMode"
                          :disabled="propReadOnly || is_cat"
                          @change="updateSelectedPerformanceMode()"
                        >
                          <option
                            v-for="(performanceMode, performanceModeIndex) in performanceModes"
                            :key="performanceModeIndex"
                          >
                            {{ performanceMode }}
                          </option>
                        </select>
                      </div>

                      <VisibleText style="margin-top: auto; margin-bottom: auto; margin-left: 2rem"
                        ><strong>Mode</strong> Switch from mean scores to volumes</VisibleText
                      >
                    </div>

                    <div
                      v-if="!is_cat"
                      style="
                        padding: 0.5rem;
                        margin: auto;
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                      "
                    >
                      <div style="display: flex">
                        <input
                          type="number"
                          id="performance-top-box"
                          v-model="selectedPerformanceTopBox"
                          style="
                            margin: 0;
                            padding: 0;
                            display: flex;
                            width: 5rem;
                            margin-left: 6.8rem;
                          "
                          :disabled="is_cat || selectedPerformanceMode == 'Volumes'"
                          @change="updateSelectedPerformanceTopBox()"
                        />
                      </div>

                      <VisibleText style="margin-top: auto; margin-bottom: auto; margin-left: 2rem"
                        ><strong>Top box mode: </strong> If set, will calculate percentage of scores
                        above this value.</VisibleText
                      >
                    </div>
                    <!-- <div>
                      <strong> <VisibleText>Requires categorical data</VisibleText>: </strong>
                    </div> -->
                    <div
                      style="
                        padding: 0.5rem;
                        margin: auto;
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                      "
                    >
                      <div style="display: flex; margin-right: 1rem">
                        <select
                          class="select"
                          id="performance-sort-by"
                          style="font-size: 1em; width: 5rem"
                          v-model="selectedTextForSentiment"
                          :disabled="propReadOnly || !is_cat"
                          @change="updateSelectedTextForSentiment()"
                        >
                          <option
                            v-for="(
                              performanceSentimentQuestion, performanceSentimentIndex
                            ) in textQuestionList"
                            :key="performanceSentimentIndex"
                            :value="performanceSentimentQuestion"
                          >
                            {{ performanceSentimentQuestion.question_title }}
                          </option>
                        </select>
                      </div>

                      <VisibleText style="margin-top: auto; margin-bottom: auto; margin-left: 1rem"
                        ><strong>Categories by sentiment: </strong> If set, will score by text
                        sentiment.
                      </VisibleText>
                    </div>

                    <div
                      v-if="selectedTextForSentiment"
                      style="
                        padding: 0.5rem;
                        margin: auto;
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                      "
                    >
                      <div style="display: flex; margin-right: 1rem">
                        <select
                          class="select"
                          id="performance-sort-by"
                          style="font-size: 1em; width: 5rem"
                          v-model="selectedSentimentMode"
                          :disabled="
                            propReadOnly ||
                            !is_cat ||
                            !selectedTextForSentiment ||
                            (selectedTimeSeries !== 'None' && selectedTimeSeries !== '')
                          "
                          @change="updateSelectedSentimentMode()"
                        >
                          <option
                            v-for="(
                              performanceMode, performanceModeIndex
                            ) in performanceSentimentModeOptions"
                            :key="performanceModeIndex"
                            :value="performanceMode"
                          >
                            {{ performanceMode }}
                          </option>
                        </select>
                      </div>

                      <VisibleText style="margin-top: auto; margin-bottom: auto; margin-left: 1rem"
                        ><strong>Sentiment mode: </strong> Combine sentiments into one score or keep
                        them separated.
                      </VisibleText>
                    </div>
                  </div>
                  <div v-if="isDateTimeCompatible">
                    <div>
                      <strong> <VisibleText>Requires date tracking</VisibleText>: </strong>
                    </div>
                    <div
                      style="
                        padding: 0.5rem;
                        margin: auto;
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                      "
                    >
                      <div style="display: flex">
                        <select
                          class="select"
                          id="time-filter-options"
                          style="font-size: 1em"
                          v-model="selectedTimeFilter"
                          :disabled="propReadOnly || !hasDateTracking"
                          @change="updateSelectedTimeFilter()"
                        >
                          <option
                            v-for="(timeFilterOption, timeFilterIndex) in TimeFilterOptions"
                            :key="timeFilterIndex"
                          >
                            {{ timeFilterOption }}
                          </option>
                        </select>
                      </div>

                      <VisibleText style="margin-top: auto; margin-bottom: auto; margin-left: 2rem"
                        ><strong>Time filter</strong> Select a period of time to filter the data
                        to</VisibleText
                      >
                    </div>
                    <div
                      style="
                        padding: 0.5rem;
                        margin: auto;
                        display: flex;
                        flex-direction: row;
                        width: 100%;
                      "
                    >
                      <div style="display: flex; flex-direction: row">
                        <div style="display: flex">
                          <select
                            class="select"
                            id="performance-time-series"
                            style="font-size: 1em"
                            v-model="selectedTimeSeries"
                            :disabled="propReadOnly || !hasDateTracking"
                            @change="updateSelectedTimeSeriesOptions()"
                          >
                            <option
                              v-for="(
                                PerformanceTimeSeriesOption, TimeSeriesOptionsIndex
                              ) in TimeSeriesOptions"
                              :key="TimeSeriesOptionsIndex"
                            >
                              {{ PerformanceTimeSeriesOption }}
                            </option>
                          </select>
                        </div>

                        <VisibleText
                          style="margin-top: auto; margin-bottom: auto; margin-left: 2rem"
                          ><strong>Time mode</strong> Select time series</VisibleText
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!--------------------------------------------
                |
                | Project Analysis save options
                |
                --------------------------------------------->
                <div
                  v-if="showSaveOptions.includes(item.uuid)"
                  style="
                    z-index: 10;
                    background-color: white;
                    border-top: 0;
                    border-radius: 0 0 4px 4px;
                    color: var(--base-colour);
                    position: absolute;
                    margin-top: 4rem;
                    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
                    border: 1px solid var(--outline-colour);
                    border-radius: 8px;
                    margin-left: -1rem;
                    width: 40rem;
                    padding: 1rem;
                  "
                >
                  <div style="display: flex; flex-direction: column">
                    <div style="display: flex; flex-direction: row">
                      <h2 style="font-size: 1.2rem">
                        <VisibleText> Saving results to a digital report </VisibleText>
                      </h2>
                      <div style="margin-left: auto">
                        <ButtonIconOnly
                          icon="remove"
                          class="modal-close-btn"
                          @click-handler="showSaveOptions = []"
                        >
                          <VisibleText>close</VisibleText>
                        </ButtonIconOnly>
                      </div>
                    </div>
                    <div style="display: flex; flex-direction: column">
                      <div v-if="activeTab == 'Text'">
                        <VisibleText>
                          For text analysis, we save the themes you have generated. We create a
                          table of the percentages, and include sentiment charts or theme charts if
                          they exist.
                        </VisibleText>
                        <h3 style="font-size: 1rem">
                          <VisibleText> Themes in this analysis: {{ numberOfThemes }} </VisibleText>
                        </h3>
                      </div>
                      <div v-if="activeTab == 'Drivers'">
                        <VisibleText>
                          For drivers analysis, we save the bar chart showing drivers, as well as a
                          priority matrix if it is available in you analysis.
                        </VisibleText>
                      </div>
                      <div v-if="activeTab == 'Outliers'">
                        <VisibleText>
                          For outliers analysis, we save a table of the outliers you picked out from
                          the interface.
                        </VisibleText>
                      </div>
                      <div v-if="activeTab == 'Benchmarking'">
                        <VisibleText>
                          For benchmarking analysis, we save a summary table of your benchmarks but
                          also additional detailed sections like a peer by peer breakdown.
                        </VisibleText>
                      </div>
                      <div v-if="activeTab == 'Performance'">
                        <VisibleText>
                          For performance analysis, we save any charts you have created.
                        </VisibleText>
                      </div>
                      <!-- Warn if this object is not ready for saving -->
                      <div
                        v-if="!canBeSaved.includes(index)"
                        class="message__block--error"
                        style="margin: 1rem; padding: 1rem"
                      >
                        <div style="display: flex; flex-direction: row">
                          <SvgIconDecorative icon="warning" />
                          <VisibleText style="font-weight: 800">Cannot save</VisibleText>
                        </div>

                        <div v-if="activeTab == 'Text'">
                          <VisibleText>
                            To save text to a report you first need to have at least one theme in
                            this analysis. Currently, this analysis has no themes saved.
                          </VisibleText>
                        </div>

                        <div v-if="activeTab == 'Drivers'">
                          <VisibleText>
                            This drivers analysis does not have valid results.
                          </VisibleText>
                        </div>
                        <div v-if="activeTab == 'Outliers'">
                          <VisibleText>
                            To save outliers to a report you first need to have at least one outlier
                            saved to the summary table at the top of the analysis.
                          </VisibleText>
                        </div>
                      </div>
                      <div v-if="canBeSaved.includes(index)">
                        <p>
                          <VisibleText>
                            Analysis is saved to a digital report (see the 'Report tab'), and can
                            include multiple slides.
                          </VisibleText>
                        </p>
                        <div>
                          <div v-if="alreadySaved">
                            <VisibleText>
                              You have already saved this snippet. Do you want to override your
                              previous save?
                            </VisibleText>
                            <div style="display: flex; flex-direction: column; margin-top: 1rem">
                              <div
                                style="display: flex; flex-direction: row; padding: 2rem"
                                v-if="selectedSlide"
                              >
                                <VisibleText style="margin-right: 1rem">Slide name:</VisibleText>
                                {{ selectedSlide.name }}
                                <button
                                  @click="saveAnalysis(false)"
                                  class="project-analysis-item__horizontal__item"
                                  style="
                                    background-color: transparent;
                                    border: 1px solid var(--outline-colour);
                                    margin-left: 1rem;
                                    border-radius: 4px;
                                    padding: 0.4rem;
                                    font-size: 0.8rem;
                                  "
                                >
                                  <SvgIconMeaningful icon="check" title="save title" />
                                  <VisibleText>Save</VisibleText>
                                </button>
                              </div>
                            </div>
                          </div>

                          <ol v-if="!alreadySaved">
                            <li>
                              <div style="padding: 0; display: flex; flex-direction: row">
                                <VisibleText> Create a new slide </VisibleText>
                              </div>
                              <div style="display: flex; flex-direction: row">
                                <input
                                  style="
                                    width: 60%;
                                    font-size: 0.8rem;
                                    margin-top: 0;
                                    color: var(--base-colour);
                                  "
                                  class="input project-analysis-item__input-input"
                                  name="slide-name"
                                  type="text"
                                  :id="item.uuid"
                                  v-model="newSlideName"
                                />
                                <button
                                  @click="saveAnalysis(true)"
                                  :disabled="!newSlideName.length"
                                  class="project-analysis-item__horizontal__item"
                                  style="
                                    background-color: transparent;
                                    border: 1px solid var(--outline-colour);
                                    margin-left: 0.25rem;
                                    border-radius: 4px;
                                    padding: 0.4rem;
                                    font-size: 0.8rem;
                                  "
                                >
                                  <SvgIconMeaningful icon="check" title="save title" />
                                  <VisibleText>Save</VisibleText>
                                </button>
                              </div>
                            </li>
                            <li v-if="reportProjectsAsSlides && reportProjectsAsSlides.length">
                              <VisibleText> Or add to an existing slide </VisibleText>
                              <div v-if="reportProjectsAsSlides.length">
                                <label style="font-size: 0.8em">
                                  <VisibleText>Existing slides:</VisibleText>
                                </label>
                                <div style="display: flex; flex-direction: row">
                                  <div class="select-wrapper">
                                    <select
                                      class="select"
                                      id="saved-slide-filter"
                                      v-model="slideForSaving"
                                    >
                                      <option
                                        v-for="(slide, slideIndex) in reportProjectsAsSlides"
                                        :value="slide"
                                        :key="slideIndex"
                                      >
                                        {{ slide.name }}
                                      </option>
                                    </select>
                                  </div>
                                  <button
                                    @click="saveAnalysis(false)"
                                    :disabled="!Object.keys(slideForSaving).length"
                                    class="project-analysis-item__horizontal__item"
                                    style="
                                      background-color: transparent;
                                      border: 1px solid var(--outline-colour);
                                      margin-left: 0.25rem;
                                      border-radius: 4px;
                                      padding: 0.4rem;
                                      font-size: 0.8rem;
                                    "
                                  >
                                    <SvgIconMeaningful icon="check" title="save title" />
                                    <VisibleText>Save</VisibleText>
                                  </button>
                                </div>
                              </div>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--------------------------------------------
                |
                | Project Analysis Object
                |
                --------------------------------------------->
                <div id="project-analysis-object" style="width: 100%">
                  <div v-if="activeTab == 'Text'">
                    <ProjectAnalysisTextItem
                      :ref="'AnalysisEditRef' + item.uuid"
                      :id="'AnalysisEditRef' + item.uuid"
                      :datasetIDQuestions="foundDatasetIDQuestions"
                      :allCategoryQuestions="categoryQuestions"
                      v-if="item.uuid"
                      :uuid="item.uuid"
                      :index="index"
                      :prop-read-only="propReadOnly"
                      :isDatasetReadOnly="isDatasetReadOnly"
                      @refresh="$emit('refresh')"
                      @updateSlides="sendRefresh"
                      style="width: 95%"
                      :expandThisAnalysis="setToExpand.includes(item.uuid) ? true : false"
                      :saveThisAnalysis="setToSave.includes(item.uuid) ? true : false"
                      :setToChangeSentiments="
                        setToChangeSentiments.includes(item.uuid) ? true : false
                      "
                      :setToChangeSmartCoverage="
                        setToChangeSmartCoverage.includes(item.uuid) ? true : false
                      "
                      @updateIncludeSmartCoverage="updateIncludeSmartCoverage($event)"
                      @updateIncludeSentiment="updateIncludeSentiment($event)"
                      :setToUpdateTimeFilter="
                        setToUpdateTimeFilter.includes(item.uuid) ? true : false
                      "
                      :selectedTimeFilter="selectedTimeFilter"
                      :setToUpdateTimeSeries="
                        setToUpdateTimeSeries.includes(item.uuid) ? true : false
                      "
                      :selectedTimeSeries="selectedTimeSeries"
                      @updateTimeSeries="updateTimeSeries($event)"
                      @updateTimeFilter="updateTimeFilter($event)"
                      :slideName="newSlideName"
                      :slideForSaving="slideForSaving"
                      :renameThisAnalysis="setToRename.includes(item.uuid) ? true : false"
                      :checkThisAIPreprocessing="
                        fetchTheseAIPreprocessing.includes(item.uuid) ? true : false
                      "
                    />
                  </div>
                  <div v-if="activeTab == 'Drivers'">
                    <ProjectAnalysisDriversItem
                      :index="index"
                      :prop-read-only="propReadOnly"
                      @refresh="$emit('refresh')"
                      @updateSlides="sendRefresh"
                      style="width: 100%"
                      :expandThisAnalysis="setToExpand.includes(item.uuid) ? true : false"
                      :renameThisAnalysis="setToRename.includes(item.uuid) ? true : false"
                      :saveThisAnalysis="setToSave.includes(item.uuid) ? true : false"
                      :setToChangeFilterTop="
                        setToChangeFilterTop.includes(item.uuid) ? true : false
                      "
                      :selectedDriversFilterTop="selectedDriversFilterTop"
                      :setToUpdateDriversModel="
                        setToUpdateDriversModel.includes(item.uuid) ? true : false
                      "
                      :modifiedDrivers="selectedDriversModel"
                      @updateFilterTop="updateFilterTop($event)"
                      @updateModels="updateDriversModel($event)"
                      @updateViableModels="updateViableModels($event)"
                      :slideName="newSlideName"
                      :slideForSaving="slideForSaving"
                      :setToUpdateTimeFilter="
                        setToUpdateTimeFilter.includes(item.uuid) ? true : false
                      "
                      :selectedTimeFilter="selectedTimeFilter"
                      :setToUpdateTimeSeries="
                        setToUpdateTimeSeries.includes(item.uuid) ? true : false
                      "
                      :selectedTimeSeries="selectedTimeSeries"
                      @updateTimeSeries="updateTimeSeries($event)"
                      @updateTimeFilter="updateTimeFilter($event)"
                    />
                  </div>
                  <div v-if="activeTab == 'Outliers'">
                    <ProjectAnalysisOutliersItem
                      :index="index"
                      @refresh="$emit('refresh')"
                      :propReadOnly="propReadOnly"
                      @updateSlides="sendRefresh"
                      style="width: 100%"
                      :expandThisAnalysis="setToExpand.includes(item.uuid) ? true : false"
                      :renameThisAnalysis="setToRename.includes(item.uuid) ? true : false"
                      :saveThisAnalysis="setToSave.includes(item.uuid) ? true : false"
                      :slideName="newSlideName"
                      :slideForSaving="slideForSaving"
                      :setToUpdateTimeFilter="
                        setToUpdateTimeFilter.includes(item.uuid) ? true : false
                      "
                      :selectedTimeFilter="selectedTimeFilter"
                      :setToUpdateTimeSeries="
                        setToUpdateTimeSeries.includes(item.uuid) ? true : false
                      "
                      :selectedTimeSeries="selectedTimeSeries"
                      @updateTimeSeries="updateTimeSeries($event)"
                      @updateTimeFilter="updateTimeFilter($event)"
                    />
                  </div>
                  <div v-if="activeTab == 'Benchmarking'">
                    <ProjectAnalysisBenchmarkingItem
                      :isReadOnly="propReadOnly"
                      :index="index"
                      :statusBenchmarksAvailable="statusBenchmarksAvailable"
                      @refresh="$emit('refresh')"
                      @updateSlides="sendRefresh"
                      style="width: 100%"
                      :expandThisAnalysis="setToExpand.includes(item.uuid) ? true : false"
                      :renameThisAnalysis="setToRename.includes(item.uuid) ? true : false"
                      :saveThisAnalysis="setToSave.includes(item.uuid) ? true : false"
                      :setToUpdateFilterByDate="
                        setToUpdateBenchmarksFilterByDate.includes(item.uuid) ? true : false
                      "
                      :selectedFilterByDate="selectedBenchmarksFilterByDate"
                      @updateFilterByDate="updateSelectedBenchmarksFilterByDateOptions"
                      :slideName="newSlideName"
                      :slideForSaving="slideForSaving"
                    />
                  </div>
                  <div v-if="activeTab == 'Performance'">
                    <ProjectAnalysisPerformanceItem
                      :index="index"
                      :retrievedSummaryTable="retrievedSummaryTable"
                      @refresh="$emit('refresh')"
                      @updateSlides="sendRefresh"
                      :propReadOnly="propReadOnly"
                      style="width: 100%"
                      :expandThisAnalysis="setToExpand.includes(item.uuid) ? true : false"
                      :renameThisAnalysis="setToRename.includes(item.uuid) ? true : false"
                      :saveThisAnalysis="setToSave.includes(item.uuid) ? true : false"
                      :setToUpdatePerformanceMode="
                        setToUpdatePerformanceMode.includes(item.uuid) ? true : false
                      "
                      :selectedPerformanceMode="selectedPerformanceMode"
                      @updatePerformanceMode="updatePerformanceMode($event)"
                      :setToUpdatePerformanceSort="
                        setToUpdatePerformanceSort.includes(item.uuid) ? true : false
                      "
                      :selectedPerformanceSort="selectedPerformanceSort"
                      @updateSortOptions="updateSelectedPerformanceSortOptions($event)"
                      :setToUpdatePerformanceTopBox="
                        setToUpdatePerformanceTopBox.includes(item.uuid) ? true : false
                      "
                      :selectedPerformanceTopBox="selectedPerformanceTopBox"
                      @updateTopBoxOptions="updateSelectedPerformanceTopBoxOptions($event)"
                      @updatePerformanceSettings="updatePerformanceSettings($event)"
                      :setToUpdateTimeFilter="
                        setToUpdateTimeFilter.includes(item.uuid) ? true : false
                      "
                      :selectedTimeFilter="selectedTimeFilter"
                      :setToUpdateTimeSeries="
                        setToUpdateTimeSeries.includes(item.uuid) ? true : false
                      "
                      :selectedTimeSeries="selectedTimeSeries"
                      @updateTimeSeries="updateTimeSeries($event)"
                      @updateTimeFilter="updateTimeFilter($event)"
                      :setToUpdateSelectedTextForSentiment="
                        setToUpdateSelectedTextForSentiment.includes(item.uuid) ? true : false
                      "
                      :setToUpdateSelectedSentimentMode="
                        setToUpdateSelectedSentimentMode.includes(item.uuid) ? true : false
                      "
                      :selectedTextForSentiment="
                        selectedTextForSentiment._id ? selectedTextForSentiment._id.$oid : ''
                      "
                      :sentimentMode="selectedSentimentMode"
                      @enableSentimentMode="enableSentimentMode($event)"
                      @updateSentimentMode="updateSentimentMode($event)"
                      :dataset="dataset"
                      :slideName="newSlideName"
                      :slideForSaving="slideForSaving"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div v-if="activeTab == 'Tools'">
              <ProjectAnalysisTools @refresh="$emit('refresh')" @updateSlides="sendRefresh" />
            </div>
            <div v-if="activeTab == 'Auto'">
              <ProjectAnalysisAuto @refresh="$emit('refresh')" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <VideoClip
      :videoShortURL="videoShortURL"
      :status="isVideoClipExpanded"
      @close="isVideoClipExpanded = false"
    ></VideoClip>
    <NewTextAnalysisModal
      v-if="availableTextQuestions.length"
      text-analysis-title="Create Text Analysis"
      :text-questions="availableTextQuestions"
      :isNewTextModalVisible="isNewTextModalVisible"
      @create-analysis="parseAndCreateFirstTextAnalysis"
      @close-text-analysis="isNewTextModalVisible = false"
    />
    <NewDriversAnalysisModal
      dependent-variable-title="Create New Drivers Analysis"
      :dependent-questions="projectCompositeIndex"
      :new-driver="true"
      :show-drivers-variables="isNewDriversModalVisible"
      @modify-vars="createNewDrivers"
      @close-drivers-variables="isNewDriversModalVisible = false"
    />
    <NewOutliersAnalysisModal
      :available-questions="availableQuestions"
      :show="isNewOutliersModalVisible"
      @confirmSelection="createNewOutliers"
      @close-modal="isNewOutliersModalVisible = false"
    />
    <NewBenchmarkingAnalysisModal
      v-if="availableBMs.length"
      :bm-questions="availableBMs"
      bm-analysis-title="Create Benchmarking Analysis"
      :isNewBMModalVisible="isNewBMModalVisible"
      @create-analysis="createNewBMs"
      @close-new-BM-analysis="isNewBMModalVisible = false"
    />
    <CreateNewPerformanceAnalysisModal
      :show="isCreatePerformanceModalVisible"
      :data="performanceQuestions"
      @confirmSelection="createNewPerformance"
      @close-modal="closePerformanceModal"
    />
  </section>
</template>

<script>
// Mixins
import DatasetDetailsMixin from '@/utils/mixins/datasetDetailsMixin.js';
import ProjectMixin from '@/components/Project/Mixins/projectMixin.js';
import ProjectReportMixin from '@/components/Project/Mixins/projectReportMixin.js';
import textAnalysisMixin from '@/components/Project/ProjectAnalysis/ProjectAnalysisText/Mixins/textAnalysisMixin.js';
import DriversAnalysisMixin from '@/components/Project/ProjectAnalysis/ProjectAnalysisDrivers/Mixins/driversAnalysisMixin.js';
import BenchmarkAnalysisMixin from '@/components/Project/ProjectAnalysis/ProjectAnalysisBenchmarking/Mixins/benchmarkAnalysisMixin.js';
import PerformanceAnalysisMixin from '@/components/Project/ProjectAnalysis/ProjectAnalysisPerformance/Mixins/performanceAnalysisMixin.js';

// Components
import SvgIconDecorative from '@/components/UI/Svg/SvgIconDecorative.vue';
import VideoClip from '@/components/VideoClip/VideoClip.vue';
import Tooltip from '@/components/UI/Tooltip.vue';
import NewTextAnalysisModal from '@/components/Project/ProjectAnalysis/ProjectAnalysisText/Components/NewTextAnalysisModal.vue';
import NewDriversAnalysisModal from '@/components/Project/ProjectAnalysis/ProjectAnalysisDrivers/Components/VariablesModal.vue';
import NewOutliersAnalysisModal from '@/components/Project/ProjectAnalysis/ProjectAnalysisOutliers/Modals/NewOutliersAnalysisModal.vue';
import NewBenchmarkingAnalysisModal from '@/components/Project/ProjectAnalysis/ProjectAnalysisBenchmarking/Components/NewBenchmarkingAnalysisModal.vue';
import BenchmarkingMessages from '@/components/Project/ProjectAnalysis/ProjectAnalysisBenchmarking/ProjectAnalysisBenchmarkingMessages.vue';
import BenchmarkingDataset from '@/models/BenchmarkingDatasetModel';
import CreateNewPerformanceAnalysisModal from '@/components/Project/ProjectAnalysis/ProjectAnalysisPerformance/Modals/CreateNewAnalysis.vue';

import SortProjects from '@/components/Project/ProjectAnalysis/Components/SortProjects.vue';
import ProjectAnalysisTextItem from '@/components/Project/ProjectAnalysis/ProjectAnalysisText/ProjectAnalysisTextItem.vue';
import ProjectAnalysisDriversItem from '@/components/Project/ProjectAnalysis/ProjectAnalysisDrivers/ProjectAnalysisDriversItem.vue';
import ProjectAnalysisOutliersItem from '@/components/Project/ProjectAnalysis/ProjectAnalysisOutliers/ProjectAnalysisOutliersItem.vue';
import ProjectAnalysisBenchmarkingItem from '@/components/Project/ProjectAnalysis/ProjectAnalysisBenchmarking/ProjectAnalysisBenchmarkingItem';
import ProjectAnalysisPerformanceItem from '@/components/Project/ProjectAnalysis/ProjectAnalysisPerformance/ProjectAnalysisPerformanceItem.vue';
import ProjectAnalysisTools from '@/components/Project/ProjectAnalysis/ProjectAnalysisTools/ProjectAnalysisTools.vue';
import ProjectAnalysisAuto from '@/components/Project/ProjectAnalysis/ProjectAnalysisAuto/ProjectAnalysisAuto.vue';
import TextAIMiniGuide from '@/components/UserGuide/TextAIMiniGuide.vue';
import LemmasMiniGuide from '@/components/UserGuide/LemmasMiniGuide.vue';

import FilterPills from '@/components/Project/ProjectAnalysis/Components/FilterPills.vue';

import ButtonIconOnly from '@/components/UI/Button/ButtonIconOnly.vue';
import SvgIconMeaningful from '@/components/UI/Svg/SvgIconMeaningful.vue';

// PigeonDoc tools
import { PigeonDocModel, DocManager, PigeonDocCollectionModel } from '@/pigeondoc/wrapper';

// Utils
import moment from 'moment';

export default {
  name: 'ProjectAnalysis',
  mixins: [
    DatasetDetailsMixin,
    ProjectReportMixin,
    ProjectMixin,
    textAnalysisMixin,
    DriversAnalysisMixin,
    BenchmarkAnalysisMixin,
    PerformanceAnalysisMixin,
  ],
  props: {
    propReadOnly: {
      default: () => false,
      type: Boolean,
    },
    isDatasetReadOnly: {
      default: () => false,
      type: Boolean,
    },
  },
  components: {
    DocManager,
    SvgIconDecorative,
    VideoClip,
    Tooltip,
    NewTextAnalysisModal,
    NewDriversAnalysisModal,
    NewOutliersAnalysisModal,
    NewBenchmarkingAnalysisModal,
    SortProjects,
    ProjectAnalysisTextItem,
    ProjectAnalysisDriversItem,
    ProjectAnalysisOutliersItem,
    ProjectAnalysisBenchmarkingItem,
    ProjectAnalysisPerformanceItem,
    ButtonIconOnly,
    SvgIconMeaningful,
    BenchmarkingMessages,
    CreateNewPerformanceAnalysisModal,
    ProjectAnalysisTools,
    ProjectAnalysisAuto,
    TextAIMiniGuide,
    LemmasMiniGuide,
    FilterPills,
  },
  data() {
    return {
      showToC: false,
      tabs: [
        { name: 'Text', level: 'Intermediate' },
        { name: 'Drivers', level: 'Basic' },
        { name: 'Outliers', level: 'Advanced' },
        { name: 'Benchmarking', level: 'Basic' },
        { name: 'Performance', level: 'Basic' },
        { name: 'Tools', level: 'Basic' },
        // { name: 'Auto', level: 'Advanced' },
      ],
      tabMode: 'showAvailable',
      docs: [],
      templates: { Blank: PigeonDocModel },
      selectedDoc: null,
      chartNode: null,
      acceptablePaths: [
        'performance',
        'drivers',
        'benchmarking',
        'text',
        'outliers',
        'tools',
        'auto',
      ], // Make this a const
      sortBy: 'new',
      videoShortURL: '',
      isVideoClipExpanded: false,
      isInfoTooltipOpen: false,
      selectedBoxes: [],
      checkedAnalysis: [],
      showAnalysisCheckOptions: [],
      showExtraOptions: [],
      showSaveOptions: [],
      setToExpand: [],
      setToDelete: [],
      setToRename: [],
      setToSave: [],
      thisCollection: {},

      reportProjectsAsSlides: [], // comes from collection_id
      newSlideName: 'Slide 1',
      slideForSaving: {},
      canBeSaved: [],
      alreadySaved: false,
      availableQuestions: [],
      saveableAnalysis: [],
      selectedSlide: {},

      // Text analysis
      numberOfThemes: 0,
      availableTextQuestions: [],
      suggestedQuestionForAnalysis: {},
      isNewTextModalVisible: false,
      isNewDriversModalVisible: false,
      showTextAIInfo: false,
      showLemmasInfo: false,
      selectedTextQuestion: {},
      fetchTheseAIPreprocessing: [],
      selectedTextQuestionIncludesSentiment: false,
      selectedTextQuestionIncludesSmartCoverage: false,
      setToChangeSentiments: [],
      setToChangeSmartCoverage: [],

      // Drivers
      projectCompositeIndex: [],
      findingSuggestedDriversVariables: false,
      suggestedDriversVariables: null,
      statusNoAutoDriversFound: false,
      selectedDriversFilterTop: -1,
      setToChangeFilterTop: [],
      selectedDriversModel: '',
      selectedDriversViableModels: [],
      setToUpdateDriversModel: [],

      // Outliers
      isNewOutliersModalVisible: false,
      findingSuggestedOutliersVariables: false,
      suggestedOutlierVariables: null,

      // benchmarking
      isNewBMModalVisible: false,
      benchmarksApproved: true,
      statusNoScaleMatches: false, //no 5point questions matched with CMT
      noBMResults: false,
      numNotApprovedBenchmarks: 0,
      numTotalBenchmarks: 0,
      findingSuggestedBenchmarkingVariables: false,
      suggestedenchmarkingVariables: null,
      selectedBenchmarksFilterByDate: null,
      setToUpdateBenchmarksFilterByDate: [],
      noResults: false,

      // performance
      retrievedSummaryTable: [],
      isCreatePerformanceModalVisible: false,
      performanceQuestions: [],
      findingSuggestedPerformanceVariables: false,
      suggestedPerformanceVariables: null,
      performanceModes: ['Means/averages', 'Volumes'],
      selectedPerformanceMode: 'Means/averages',
      setToUpdatePerformanceMode: [],
      setToUpdatePerformanceTopBox: [],
      selectedPerformanceTopBox: -1,
      performanceSortOptions: ['Original', 'Lowest to Highest', 'Highest to Lowest'],
      setToUpdatePerformanceSort: [],
      selectedPerformanceSort: 'Original',
      setToUpdateSelectedTextForSentiment: [],
      selectedTextForSentiment: '',
      selectedSentimentMode: '',
      setToUpdateSelectedSentimentMode: [],
      performanceSentimentModeOptions: ['Single score', '5-point scale'],
      is_cat: false,

      // All
      setToUpdateTimeFilter: [],
      selectedTimeFilter: 'All data',
      TimeFilterOptions: [
        'All data',
        'Today',
        'Yesterday',
        'Last seven days',
        'Last week',
        'This month',
        'Last month',
        'This quarter',
        'Last quarter',
        'This year',
        'Last year',
      ],
      setToUpdateTimeSeries: [],
      selectedTimeSeries: 'None',
      TimeSeriesOptions: ['None', 'Hours', 'Days', 'Weeks', 'Months', 'Quarters', 'Years'],
    };
  },
  computed: {
    activeTab() {
      const tab = this.$route.path.split('/').pop();
      return tab.charAt(0).toUpperCase() + tab.substr(1).toLowerCase();
    },
    textQuestionList() {
      let question_list = [];
      for (let i = 0; i < this.availableTextQuestions.length; i++) {
        if (
          this.availableTextQuestions[i]['text_preprocessing'] &&
          this.availableTextQuestions[i]['text_preprocessing']['complete']
        ) {
          question_list.push(this.availableTextQuestions[i]);
        }
      }
      question_list.unshift({ question_title: 'None' });
      return question_list;
    },
    tabsWithMissing() {
      let reformatedTabs = [];
      for (let i = 0; i < this.tabs.length; i++) {
        let newTab = this.tabs[i];
        if (!this.hasTextQuestions && newTab.name == 'Text') {
          newTab.deactivate = true;
        }
        if (!this.hasBMQuestions && newTab.name == 'Benchmarking') {
          newTab.deactivate = true;
        }
        if (
          !this.hasScaleQuestions &&
          (newTab.name == 'Performance' || newTab.name == 'Outliers')
        ) {
          newTab.deactivate = true;
        }
        if (!this.hasScaleQuestions && newTab.name == 'Drivers') {
          newTab.deactivate = true;
        }
        if (!this.categoryQuestions.length && newTab.name == 'Outliers') {
          newTab.deactivate = true;
        }
        if (newTab.name == 'Auto') {
          newTab.deactivate = true;
        }

        reformatedTabs.push(newTab);
      }
      return reformatedTabs;
    },
    reformatedTabs() {
      if (this.tabMode === 'showAll') {
        return this.tabs;
      }
      let removeMissing = [];
      for (let i = 0; i < this.tabsWithMissing.length; i++) {
        if (this.tabsWithMissing[i].deactivate !== true) {
          removeMissing.push(this.tabsWithMissing[i]);
        }
      }
      return removeMissing;
    },
    hasDateTracking() {
      let status = false;
      if (this.dataset.created_on_column_id) {
        status = true;
      }
      return status;
    },
    hasMissingAnalysis() {
      let foundMissing = false;
      for (let i = 0; i < this.tabsWithMissing.length; i++) {
        if (this.tabsWithMissing[i].deactivate) {
          foundMissing = true;
          break;
        }
      }
      return foundMissing;
    },
    modalOpen() {
      return this.$store.getters['getModalOpen'];
    },
    thisCollectionId() {
      return this.project.collection_id;
    },
    hasTextQuestions() {
      if (this.clientTextQuestions && this.clientTextQuestions.length) {
        return true;
      }
      return false;
    },
    hasScaleQuestions() {
      let foundVars = [];
      if (this.clientQuestions && this.clientQuestions.length) {
        for (let i = 0; i < this.clientQuestions.length; i++) {
          if (
            this.clientQuestions[i].approved_data_type &&
            this.clientQuestions[i].approved_data_type.includes('SCALE')
          ) {
            foundVars.push(this.clientQuestions[i]);
          }
        }
      }
      if (foundVars.length) {
        return true;
      }
      return false;
    },
    textAIStatus() {
      if (
        this.selectedTextQuestion.text_preprocessing &&
        this.selectedTextQuestion.text_preprocessing.complete
      ) {
        return 'complete';
      }
      if (
        this.selectedTextQuestion.text_preprocessing &&
        this.selectedTextQuestion.text_preprocessing.processing
      ) {
        return 'processing';
      }
      return '';
    },
    isDateTimeCompatible() {
      let status = false;
      if (
        this.activeTab == 'Text' ||
        this.activeTab == 'Drivers' ||
        this.activeTab == 'Performance' ||
        this.activeTab == 'Outliers'
      ) {
        status = true;
      }
      return status;
    },
    foundDatasetIDQuestions() {
      let foundVars = [];
      if (this.clientQuestions && this.clientQuestions.length) {
        for (let i = 0; i < this.clientQuestions.length; i++) {
          if (
            this.clientQuestions[i].approved_data_type &&
            this.clientQuestions[i].approved_data_type.includes('ID')
          ) {
            if (this.clientQuestions[i]._id && this.clientQuestions[i]._id.$oid) {
              foundVars.push(this.clientQuestions[i]);
            }
          }
        }
      }
      return foundVars;
    },
    categoryQuestions() {
      let foundVars = [];
      if (this.clientQuestions && this.clientQuestions.length) {
        for (let i = 0; i < this.clientQuestions.length; i++) {
          if (
            this.clientQuestions[i].approved_data_type &&
            this.clientQuestions[i].approved_data_type.includes('CAT')
          ) {
            foundVars.push(this.clientQuestions[i]);
          }
        }
      }
      return foundVars;
    },
    hasBMQuestions() {
      if (this.matchesDetails && Object.keys(this.matchesDetails).length) {
        return true;
      }
      return false;
    },
    availableBMs() {
      let availableBMs = [];
      for (let i = 0; i < this.benchmarks.length; i++) {
        let localID = '';
        if (this.benchmarks[i].client_question_id) {
          localID = this.benchmarks[i].client_question_id;
        }
        if (localID) {
          let foundQuestion = {};
          for (let x = 0; x < this.clientQuestions.length; x++) {
            let thisID = '';
            if (this.clientQuestions[x]._id) {
              if (this.clientQuestions[x]._id.$oid) {
                thisID = this.clientQuestions[x]._id.$oid;
              } else {
                thisID = this.clientQuestions[x]._id;
              }
            }
            if (thisID == localID) {
              foundQuestion = this.clientQuestions[x];
            }
          }
          if (foundQuestion) {
            availableBMs.push(foundQuestion);
          }
        }
      }

      return availableBMs;
    },
    statusBenchmarksPendingApproval() {
      return !this.benchmarksApproved;
    },
    statusBenchmarksAvailable() {
      return (
        (this.benchmarksApproved || this.statusBenchmarksPendingApproval) &&
        !this.statusNoScaleMatches
      );
    },
    statusBenchmarksNotAvailable() {
      return !this.benchmarksApproved || this.statusNoScaleMatches || this.noResults;
    },
    sortedItems: function () {
      if (this.project) {
        if (this.activeTab == 'Text') {
          if (this.project.textAnalysisObjects) {
            if (this.project.textAnalysisObjects.length > 1) {
              if (this.sortBy === 'old') {
                let theseObjects = this.project.textAnalysisObjects;
                theseObjects.sort((a, b) => {
                  return a.last_modified_on - b.last_modified_on;
                });
                return theseObjects;
              } else {
                let theseObjects = this.project.textAnalysisObjects;
                theseObjects.sort((a, b) => {
                  return b.last_modified_on - a.last_modified_on;
                });
                return theseObjects;
              }
            } else {
              return this.project.textAnalysisObjects;
            }
          }
        }
        if (this.activeTab == 'Drivers') {
          if (this.project.driversAnalysis) {
            if (this.project.driversAnalysis.length > 1) {
              if (this.sortBy === 'old') {
                let theseObjects = this.project.driversAnalysis;
                theseObjects.sort((a, b) => {
                  return a.last_modified_on - b.last_modified_on;
                });
                return theseObjects;
              } else {
                let theseObjects = this.project.driversAnalysis;
                theseObjects.sort((a, b) => {
                  return b.last_modified_on - a.last_modified_on;
                });
                return theseObjects;
              }
            } else {
              return this.project.driversAnalysis;
            }
          }
        }
        if (this.activeTab == 'Outliers') {
          if (this.project.outliersAnalysis) {
            if (this.project.outliersAnalysis.length > 1) {
              if (this.sortBy === 'old') {
                let theseObjects = this.project.outliersAnalysis;
                theseObjects.sort((a, b) => {
                  return a.last_modified_on - b.last_modified_on;
                });
                return theseObjects;
              } else {
                let theseObjects = this.project.outliersAnalysis;
                theseObjects.sort((a, b) => {
                  return b.last_modified_on - a.last_modified_on;
                });
                return theseObjects;
              }
            } else {
              return this.project.outliersAnalysis;
            }
          }
        }
        if (this.activeTab == 'Benchmarking') {
          if (this.project.benchmarkAnalysis) {
            if (this.project.benchmarkAnalysis.length > 1) {
              if (this.sortBy === 'old') {
                let theseObjects = this.project.benchmarkAnalysis;
                theseObjects.sort((a, b) => {
                  return a.last_modified_on - b.last_modified_on;
                });
                return theseObjects;
              } else {
                let theseObjects = this.project.benchmarkAnalysis;
                theseObjects.sort((a, b) => {
                  return b.last_modified_on - a.last_modified_on;
                });
                return theseObjects;
              }
            } else {
              return this.project.benchmarkAnalysis;
            }
          }
        }
        if (this.activeTab == 'Performance') {
          if (this.project.performanceAnalysis) {
            if (this.project.performanceAnalysis.length > 1) {
              if (this.sortBy === 'old') {
                let theseObjects = this.project.performanceAnalysis;
                theseObjects.sort((a, b) => {
                  return a.last_modified_on - b.last_modified_on;
                });
                return theseObjects;
              } else {
                let theseObjects = this.project.performanceAnalysis;
                theseObjects.sort((a, b) => {
                  return b.last_modified_on - a.last_modified_on;
                });
                return theseObjects;
              }
            } else {
              return this.project.performanceAnalysis;
            }
          }
        }
        // if (this.activeTab == 'Tools') {
        // }
      }
      return [];
    },
    hasOptions() {
      if (
        this.activeTab == 'Text' ||
        this.activeTab == 'Drivers' ||
        this.activeTab == 'Performance' ||
        this.activeTab == 'Benchmarking' ||
        this.activeTab == 'Outliers'
      ) {
        return true;
      }
      return false;
    },
    FilterParams() {
      let filter_params = {};

      if (
        this.checkedAnalysis[0] &&
        this.checkedAnalysis[0].filter_params &&
        Object.keys(this.checkedAnalysis[0].filter_params).length
      ) {
        return this.checkedAnalysis[0].filter_params;
      }
      return filter_params;
    },
    OUTLIERS_SERVICE() {
      return this.$services.OUTLIERS_SERVICE;
    },
    // Drivers analysis
    // projectCompositeIndex() {
    //   if (this.project) {
    //     if (this.project.settings) {
    //       return this.project.settings.performanceMeasure
    //         ? this.project.settings.performanceMeasure.clientQuestionsIds
    //         : []
    //     }
    //   }
    //   return []
    // },
  },
  async created() {
    await this.getReportsFromCollection(); // Get reports which act as slides, from the collection_id
    await this.assignAnalysisUUIDToSlides(); // Used for legacy slides that did not save the UUID ahead of time
    await this.getDatasetStatus(); // for benchmarking
    await this.redirectIfEmpty();
  },
  mounted() {
    this.selectedDoc = 0;
    // Auto-open ToC
    if (this.project.collection_id) {
      this.openToC();
    } else {
      this.closeToC();
    }
  },
  watch: {
    activeTab: {
      immediate: true,
      handler: function (val) {
        if (!val || val === '') return;
        document.title = `${this.$store.getters['project/getProject'].name} - Analysis - ${val} || ${this.$theme.theme.pageTitle}`;
        if (this.project) {
          const tab = this.$route.path.split('/').pop();
          if (tab) {
            if (this.acceptablePaths.includes(tab)) {
              let cleanedProject = this.deepCloneObj(this.project);
              cleanedProject.settings.lastOpenedTab = tab;
              cleanedProject.id = this.project.id;
              if (cleanedProject._id) {
                delete cleanedProject._id;
              }
              if (!this.propReadOnly) {
                this.saveProject(cleanedProject);
              }

              this.sendRefresh();
            }
          }
          this.updateAllQuestions();
          this.showAnalysisCheckOptions = [];
          this.selectedBoxes = [];
          this.checkedAnalysis = [];
        }
      },
    },
    thisCollectionId: async function (val) {
      if (!val) {
        this.closeToC();
        return;
      } else {
        this.openToC();
        return;
      }
    },
    confirmStatus: async function (val) {
      if (val && this.confirmSourceComponent === 'analysis' && this.confirmType === 'delete') {
        this.deleteAnalysis();
      }
    },
    textAIStatus: {
      immediate: true,
      handler: function (status) {
        if (status && status == 'complete') {
          this.stopTimer();
        }
      },
    },
  },
  beforeUnmount() {
    this.stopTimer();
  },
  methods: {
    redirectIfEmpty() {
      if (this.activeTab == '') {
        if (this.hasTextQuestions) {
          this.$router.push({
            path: `/project/${this.project.id}/analysis/text`,
          });
        } else if (this.hasScaleQuestions) {
          this.$router.push({
            path: `/project/${this.project.id}/analysis/drivers`,
          });
        } else {
          this.$router.push({
            path: `/project/${this.project.id}/analysis/tools`,
          });
        }
      }
    },
    openToC() {
      this.showToC = true;
    },
    closeToC() {
      this.showToC = false;
    },
    openVideo(shortUrl) {
      this.videoShortURL = shortUrl;
      this.isVideoClipExpanded = !this.isVideoClipExpanded;
    },
    onClickOpen() {
      let analysisToOpen = this.deepCloneObj(this.checkedAnalysis);
      for (let i = 0; i < analysisToOpen.length; i++) {
        this.setToExpand.push(analysisToOpen[i].uuid);
      }
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
    },
    onClickMoreOptions() {
      let analysisToOpen = this.deepCloneObj(this.checkedAnalysis);
      this.showExtraOptions = [];
      for (let i = 0; i < analysisToOpen.length; i++) {
        this.showExtraOptions.push(analysisToOpen[i].uuid);
      }
      // this.showAnalysisCheckOptions = []
      // this.showSaveOptions = []
      // this.selectedBoxes = []
      // this.checkedAnalysis = []
      if (this.activeTab == 'Text') {
        this.setSelectedTextQuestion();
      }
      if (this.isDateTimeCompatible) {
        this.setSelectedTimeFilters();
      }
      if (this.checkedAnalysis[0] && this.checkedAnalysis[0].mode) {
        if (this.checkedAnalysis[0].mode == 'Volumes') {
          this.setSelectedMode('Volumes');
        }
        if (this.checkedAnalysis[0].mode == 'Means/averages') {
          this.setSelectedMode('Means/averages');
        }
      }
      if (this.activeTab == 'Performance') {
        // special rules for cat
        this.is_cat = false;

        let use_this_sentiment = '';
        if (this.checkedAnalysis[0]['selected_text_for_sentiment']) {
          use_this_sentiment = this.checkedAnalysis[0]['selected_text_for_sentiment'];
          let sentiment_question = this.textQuestionList.filter(
            (question) => question._id && question._id.$oid == use_this_sentiment,
          );
          if (sentiment_question) {
            this.selectedTextForSentiment = sentiment_question[0];
          }
        }

        if (this.checkedAnalysis[0]['selectedQuestions']) {
          for (let i = 0; i < this.checkedAnalysis[0]['selectedQuestions'].length; i++) {
            let this_question = this.availableQuestions.filter(
              (question) => question._id.$oid == this.checkedAnalysis[0]['selectedQuestions'][i][0],
            );
            if (this_question[0]) {
              if (
                this_question[0].approved_data_type &&
                this_question[0].approved_data_type == 'CAT'
              ) {
                this.is_cat = true;
              }
            }
          }
        }
        if (this.is_cat == true) {
          this.setSelectedMode('Volumes');
        }
      }
    },
    changeSentimentMode() {
      let setToChangeSentiments = [];
      let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
      setToChangeSentiments.push(analysisToChange[0].uuid);
      this.setToChangeSentiments = setToChangeSentiments;
    },
    updateIncludeSentiment(status) {
      this.setToChangeSentiments = [];
      this.selectedTextQuestionIncludesSentiment = status;
    },
    changeSmartCoverage() {
      let setToChangeSmartCoverage = [];
      let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
      setToChangeSmartCoverage.push(analysisToChange[0].uuid);
      this.setToChangeSmartCoverage = setToChangeSmartCoverage;
    },
    updateIncludeSmartCoverage(status) {
      this.setToChangeSmartCoverage = [];
      this.selectedTextQuestionIncludesSmartCoverage = status;
    },
    updateSelectedDriversFilterTop() {
      if (this.selectedDriversFilterTop >= 1) {
        let setToChangeFilterTop = [];
        let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
        setToChangeFilterTop.push(analysisToChange[0].uuid);
        this.setToChangeFilterTop = setToChangeFilterTop;
      }
      if (this.selectedDriversFilterTop < 1) {
        this.selectedDriversFilterTop = 1;
        let setToChangeFilterTop = [];
        let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
        setToChangeFilterTop.push(analysisToChange[0].uuid);
        this.setToChangeFilterTop = setToChangeFilterTop;
      }
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.showExtraOptions = [];
    },
    updateFilterTop(filter) {
      this.selectedDriversFilterTop = filter;
    },
    updateDriversModel(model) {
      this.selectedDriversModel = model;
    },
    updateViableModels(models) {
      this.selectedDriversViableModels = models;
      this.setToUpdateDriversModel = [];
    },
    updateSelectedDriverModel() {
      let setToUpdateDriversModel = [];
      let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
      setToUpdateDriversModel.push(analysisToChange[0].uuid);
      this.setToUpdateDriversModel = setToUpdateDriversModel;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.showExtraOptions = [];
    },
    updateSelectedPerformanceMode() {
      // if (this.selectedPerformanceMode == 'Means/averages') {
      //   this.selectedPerformanceMode = 'Volumes';
      // } else {
      //   this.selectedPerformanceMode = 'Means/averages';
      // }
      let setToUpdatePerformanceMode = [];
      let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
      setToUpdatePerformanceMode.push(analysisToChange[0].uuid);
      this.setToUpdatePerformanceMode = setToUpdatePerformanceMode;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.showExtraOptions = [];
    },
    updatePerformanceMode(mode) {
      this.selectedPerformanceMode = mode;
      this.setToUpdatePerformanceMode = [];
    },
    updateSelectedPerformanceSort() {
      let setToUpdatePerformanceSort = [];
      let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
      setToUpdatePerformanceSort.push(analysisToChange[0].uuid);
      this.setToUpdatePerformanceSort = setToUpdatePerformanceSort;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.showExtraOptions = [];
    },
    updateSelectedPerformanceSortOptions(sort_by) {
      this.selectedPerformanceSort = sort_by;
      this.setToUpdatePerformanceSort = [];
    },
    updateSelectedPerformanceTopBox() {
      let setToUpdatePerformanceTopBox = [];
      let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
      setToUpdatePerformanceTopBox.push(analysisToChange[0].uuid);
      this.setToUpdatePerformanceTopBox = setToUpdatePerformanceTopBox;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.showExtraOptions = [];
    },
    updateSelectedPerformanceTopBoxOptions(threshold) {
      this.selectedPerformanceTopBox = threshold;
      this.setToUpdatePerformanceTopBox = [];
    },
    updateSelectedTextForSentiment() {
      let setToUpdateSelectedTextForSentiment = [];
      let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
      setToUpdateSelectedTextForSentiment.push(analysisToChange[0].uuid);
      this.setToUpdateSelectedTextForSentiment = setToUpdateSelectedTextForSentiment;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.showExtraOptions = [];
    },
    updateSelectedSentimentMode() {
      let setToUpdateSelectedSentimentMode = [];
      let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
      setToUpdateSelectedSentimentMode.push(analysisToChange[0].uuid);
      this.setToUpdateSelectedSentimentMode = setToUpdateSelectedSentimentMode;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.showExtraOptions = [];
    },
    updateSentimentMode(selectedMode) {
      this.selectedSentimentMode = selectedMode;
      this.setToUpdateSelectedSentimentMode = [];
    },

    enableSentimentMode(selectedText) {
      this.selectedTextForSentiment = selectedText;
      this.setToUpdateSelectedTextForSentiment = [];
    },

    updatePerformanceSettings(sort_by, threshold) {
      this.selectedPerformanceSort = sort_by;
      this.selectedPerformanceTopBox = threshold;
    },
    updateTimeFilter(filter) {
      this.selectedTimeFilter = filter;
      this.setToUpdateTimeFilter = [];
    },
    updateSelectedTimeFilter() {
      let setToUpdateTimeFilter = [];
      let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
      setToUpdateTimeFilter.push(analysisToChange[0].uuid);
      this.setToUpdateTimeFilter = setToUpdateTimeFilter;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.showExtraOptions = [];
    },

    updateSelectedTimeSeriesOptions() {
      let setToUpdateTimeSeries = [];
      let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
      setToUpdateTimeSeries.push(analysisToChange[0].uuid);
      this.setToUpdateTimeSeries = setToUpdateTimeSeries;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.showExtraOptions = [];
    },
    updateTimeSeries(time_series) {
      this.selectedTimeSeries = time_series;
      this.setToUpdateTimeSeries = [];
    },
    onClickRename() {
      const analysisToRename = this.deepCloneObj(this.checkedAnalysis);
      this.setToRename.push(analysisToRename[0].uuid);
      setTimeout(() => {
        this.setToRename = [];
      }, 200);
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
    },
    updateSelectedBenchmarksFilterByDate() {
      let setToUpdateBenchmarksFilterByDate = [];
      let analysisToChange = this.deepCloneObj(this.checkedAnalysis);
      setToUpdateBenchmarksFilterByDate.push(analysisToChange[0].uuid);
      this.setToUpdateBenchmarksFilterByDate = setToUpdateBenchmarksFilterByDate;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.showExtraOptions = [];
    },
    updateSelectedBenchmarksFilterByDateOptions(filter) {
      this.selectedBenchmarksFilterByDate = filter;
      this.setToUpdateBenchmarksFilterByDate = [];
    },
    async preprocessAI() {
      if (Object.keys(this.selectedTextQuestion).length) {
        if (this.selectedTextQuestion._id) {
          let questionID = this.selectedTextQuestion._id;
          if (this.selectedTextQuestion._id.$oid) {
            questionID = this.selectedTextQuestion._id.$oid;
          }

          await this.DATASETS_SERVICE.preproccessAI({
            client_question_id: questionID,
          });
          await this.updateAllQuestions();
          this.setSelectedTextQuestion();
        }
      }
    },
    async checkAIProcessingAnalysis() {
      if (Object.keys(this.selectedTextQuestion).length) {
        if (this.selectedTextQuestion._id) {
          let questionID = this.selectedTextQuestion._id;
          if (this.selectedTextQuestion._id.$oid) {
            questionID = this.selectedTextQuestion._id.$oid;
            const results = await this.DATASETS_SERVICE.checkAIProcessingService({
              client_question_id: questionID,
            });
            if (results.status == 'complete') {
              this.fetchAIPreprocessing(this.checkedAnalysis[0].uuid);
              this.stopTimer();
              await this.updateAllQuestions();
              this.setSelectedTextQuestion();
            }
            if (results.status == 'not_started') {
              this.stopTimer();
            }
          }
        }
      }
    },
    // for text AI status checking
    incrementCounter() {
      this.counter++;
    },
    startTimer() {
      this.timer = setTimeout(
        function repeat() {
          this.checkAIProcessingAnalysis();
          this.incrementCounter();
          this.timer = setTimeout(repeat.bind(this), 2000); // Adjust interval as needed
        }.bind(this),
        1000,
      );
    },
    stopTimer() {
      clearTimeout(this.timer);
    },
    async onClickDuplicate() {
      const analysisToDuplicate = this.deepCloneObj(this.checkedAnalysis);
      let newAnalysis = analysisToDuplicate[0];
      const newUUID = await this.$pigeonline.createUUID();
      const oldUUID = analysisToDuplicate[0].uuid;

      newAnalysis.uuid = newUUID;
      newAnalysis.last_modified_on = moment().valueOf();
      newAnalysis.saved_node_ids = [];

      // 1. Insert new analysis into project BEFORE creating themes
      if (this.activeTab == 'Text') {
        this.project.textAnalysisObjects.unshift(newAnalysis);
      }
      if (this.activeTab == 'Drivers') {
        this.project.driversAnalysis.unshift(newAnalysis);
      }
      if (this.activeTab == 'Outliers') {
        this.project.outliersAnalysis.unshift(newAnalysis);
      }
      if (this.activeTab == 'Benchmarking') {
        this.project.benchmarkAnalysis.unshift(newAnalysis);
      }
      if (this.activeTab == 'Performance') {
        this.project.performanceAnalysis.unshift(newAnalysis);
      }

      // 2. Save project so backend knows about the new UUID
      await this.cleanAndSaveProject();

      // 3. Now fetch original themes
      if (this.activeTab == 'Text') {
        const fetchedThemes = await this.TEXT_SERVICE.fetchTextThemes({
          text_analysis_uuid: oldUUID,
        });

        // 4. Clean themes for duplication
        const cleanedThemes = fetchedThemes.map((t) => ({
          name: t.name,
          theme_color: t.theme_color,
          keyword_objects: t.keyword_objects || [],
          notes: t.notes || [],
          dropped: t.dropped || [],
          ml_dropped: t.ml_dropped || [],
          // human_dropped_ml_notes: human_dropped_ml_notes.human_dropped_ml_notes || [], // Not necessary to keep this on a duplicated theme since we delete the source

          // Copy coverage-related fields
          coverage: t.coverage || {},
          filtered_coverage: t.filtered_coverage || {},

          // Status can be copied or set to "updating"
          status: t.status || 'ready',

          // New timestamp
          created_on: moment().valueOf(),
        }));

        // 5. Bulk-create themes for the new analysis
        if (cleanedThemes.length) {
          await this.TEXT_SERVICE.createThemes({
            text_analysis_uuid: newUUID,
            themes: cleanedThemes,
          });
        }
      }

      // 6. Reset UI state
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
    },

    async onClickSave(index) {
      let analysisToOpen = this.deepCloneObj(this.checkedAnalysis);
      for (let i = 0; i < analysisToOpen.length; i++) {
        this.showSaveOptions.push(analysisToOpen[i].uuid);
      }
      // for now saving only works for one at a time
      await this.updateCanBeSaved(index);
      await this.checkDefaultSlideName();
      await this.setFirstOptionInSlides();
    },

    onClickDelete() {
      let analysisToOpen = this.deepCloneObj(this.checkedAnalysis);
      this.setConfirmText({
        btn: 'Delete?',
        title: 'Delete analysis?',
      });
      this.setConfirmType('delete');
      this.setConfirmSourceComponent('analysis'); // double check
      this.setConfirmStatus(false);
      this.setConfirmIsVisible(analysisToOpen.length > -1);
    },
    // PigeonDoc Table of Contents can have nodes deleted here
    async deleteTheseNodes(doc_details) {
      let cleanedProject = this.deepCloneObj(this.project);
      if (cleanedProject._id) {
        delete cleanedProject._id;
      }

      // if a slide is found, delete the entire contents
      const found_slide = doc_details.nodes.filter((node) => node.type == 'slide');
      if (found_slide.length && found_slide[0].id) {
        let slide_nodes = [];

        for (let b = 0; b < this.reportProjectsAsSlides.length; b++) {
          if (this.reportProjectsAsSlides[b].id == found_slide[0].id) {
            for (let c = 0; c < this.reportProjectsAsSlides[b].nodes.length; c++) {
              if (this.reportProjectsAsSlides[b].nodes[c].type == 'section') {
                let subnodes = this.reportProjectsAsSlides[b].nodes[c].content.map(
                  (subnode) => subnode.uuid,
                );
                slide_nodes = slide_nodes.concat(subnodes);
              }
              slide_nodes.push(this.reportProjectsAsSlides[b].nodes[c].uuid);
            }
            await this.$pigeonline.projects.delete(found_slide[0].id);
            // Also delete from the collection that references it

            let new_docIds = this.thisCollection.docIds.filter(
              (docId) => docId != found_slide[0].id,
            );

            this.thisCollection.docIds = new_docIds;
            await this.$pigeonline.projects.update(this.thisCollection);

            // Also, if is the slide in the reports field in project, remove that as well.
            if (cleanedProject.report == found_slide[0].id) {
              cleanedProject.report = null;
            }
          }
        }

        // Strip "saved_node_ids" from ProjectAnalysis
        for (let z = 0; z < cleanedProject.textAnalysisObjects.length; z++) {
          if (
            this.project.textAnalysisObjects[z].saved_node_ids &&
            this.project.textAnalysisObjects[z].saved_node_ids.length
          ) {
            this.project.textAnalysisObjects[z].saved_node_ids = this.project.textAnalysisObjects[
              z
            ].saved_node_ids.filter((saved_node) => !slide_nodes.includes(saved_node));
          }
        }
        for (let z = 0; z < this.project.driversAnalysis; z++) {
          if (
            this.project.driversAnalysis[z].saved_node_ids &&
            this.project.driversAnalysis[z].saved_node_ids.length
          ) {
            this.project.driversAnalysis[z].saved_node_ids = this.project.driversAnalysis[
              z
            ].saved_node_ids.filter((saved_node) => !slide_nodes.includes(saved_node));
          }
        }
        for (let z = 0; z < this.project.outliersAnalysis; z++) {
          if (
            this.project.outliersAnalysis[z].saved_node_ids &&
            this.project.outliersAnalysis[z].saved_node_ids.length
          ) {
            this.project.outliersAnalysis[z].saved_node_ids = this.project.outliersAnalysis[
              z
            ].saved_node_ids.filter((saved_node) => !slide_nodes.includes(saved_node));
          }
        }
        for (let z = 0; z < this.project.benchmarkAnalysis; z++) {
          if (
            this.project.benchmarkAnalysis[z].saved_node_ids &&
            this.project.benchmarkAnalysis[z].saved_node_ids.length
          ) {
            this.project.benchmarkAnalysis[z].saved_node_ids = this.project.benchmarkAnalysis[
              z
            ].saved_node_ids.filter((saved_node) => !slide_nodes.includes(saved_node));
          }
        }
        for (let z = 0; z < this.project.performanceAnalysis; z++) {
          if (
            this.project.performanceAnalysis[z].saved_node_ids &&
            this.project.performanceAnalysis[z].saved_node_ids.length
          ) {
            this.project.performanceAnalysis[z].saved_node_ids = this.project.performanceAnalysis[
              z
            ].saved_node_ids.filter((saved_node) => !slide_nodes.includes(saved_node));
          }
        }
        this.project = cleanedProject;
        await this.cleanAndSaveProject();
      } else {
        // Every node has a uuid. It is either a primary node or a subnode inside a section. These have been passed by the ToC
        for (let i = 0; i < doc_details.nodes.length; i++) {
          const uuid_to_delete = doc_details.nodes[i].uuid;
          let subnodes_to_delete = [];
          let section_uuid; // if this gets filled, then the node is a subnode with a parent node (called a section). Not the same as sending a section itself for deletion
          if (doc_details.nodes[i].parent_uuid) {
            section_uuid = doc_details.nodes[i].parent_uuid;
          }
          // Delete from the project itself
          for (let b = 0; b < this.reportProjectsAsSlides.length; b++) {
            if (this.reportProjectsAsSlides[b].nodes) {
              for (let c = 0; c < this.reportProjectsAsSlides[b].nodes.length; c++) {
                // Found a match in a slide between nodes for deletion
                if (
                  this.reportProjectsAsSlides[b].nodes[c].uuid == uuid_to_delete ||
                  this.reportProjectsAsSlides[b].nodes[c].uuid == section_uuid
                ) {
                  let project = await this.$pigeonline.projects.getByID(
                    PigeonDocModel,
                    this.reportProjectsAsSlides[b].id,
                  );
                  if (project && project.nodes) {
                    // Remove subnode mathces
                    for (let x = 0; x < project.nodes.length; x++) {
                      // If the request is a section, keep IDs to delete in the Analysis objects later
                      if (
                        project.nodes[x].type == 'section' &&
                        this.reportProjectsAsSlides[b].nodes[c].uuid == uuid_to_delete
                      ) {
                        let subnode_ids = project.nodes[x].content.map((subnode) => subnode.uuid);
                        subnodes_to_delete = subnodes_to_delete.concat(subnode_ids);
                      }
                      if (project.nodes[x].uuid == section_uuid) {
                        project.nodes[x].content = project.nodes[x].content.filter(
                          (item) => item.uuid !== uuid_to_delete,
                        );
                      }
                    }
                    // Remove direct matches
                    project.nodes = project.nodes.filter((item) => item.uuid !== uuid_to_delete);

                    await this.$pigeonline.projects.update(project);
                  }
                }
              }
            }
          }
          // Strip "saved_node_ids" from ProjectAnalysis
          for (let z = 0; z < cleanedProject.textAnalysisObjects.length; z++) {
            if (
              this.project.textAnalysisObjects[z].saved_node_ids &&
              this.project.textAnalysisObjects[z].saved_node_ids.length
            ) {
              this.project.textAnalysisObjects[z].saved_node_ids = this.project.textAnalysisObjects[
                z
              ].saved_node_ids.filter(
                (saved_node) =>
                  saved_node !== uuid_to_delete && !subnodes_to_delete.includes(saved_node),
              );
            }
          }
          for (let z = 0; z < this.project.driversAnalysis; z++) {
            if (
              this.project.driversAnalysis[z].saved_node_ids &&
              this.project.driversAnalysis[z].saved_node_ids.length
            ) {
              this.project.driversAnalysis[z].saved_node_ids = this.project.driversAnalysis[
                z
              ].saved_node_ids.filter(
                (saved_node) => saved_node !== uuid_to_delete && saved_node !== section_uuid,
              );
            }
          }
          for (let z = 0; z < this.project.outliersAnalysis; z++) {
            if (
              this.project.outliersAnalysis[z].saved_node_ids &&
              this.project.outliersAnalysis[z].saved_node_ids.length
            ) {
              this.project.outliersAnalysis[z].saved_node_ids = this.project.outliersAnalysis[
                z
              ].saved_node_ids.filter(
                (saved_node) => saved_node !== uuid_to_delete && saved_node !== section_uuid,
              );
            }
          }
          for (let z = 0; z < this.project.benchmarkAnalysis; z++) {
            if (
              this.project.benchmarkAnalysis[z].saved_node_ids &&
              this.project.benchmarkAnalysis[z].saved_node_ids.length
            ) {
              this.project.benchmarkAnalysis[z].saved_node_ids = this.project.benchmarkAnalysis[
                z
              ].saved_node_ids.filter(
                (saved_node) => saved_node !== uuid_to_delete && saved_node !== section_uuid,
              );
            }
          }
          for (let z = 0; z < this.project.performanceAnalysis; z++) {
            if (
              this.project.performanceAnalysis[z].saved_node_ids &&
              this.project.performanceAnalysis[z].saved_node_ids.length
            ) {
              this.project.performanceAnalysis[z].saved_node_ids = this.project.performanceAnalysis[
                z
              ].saved_node_ids.filter(
                (saved_node) => saved_node !== uuid_to_delete && saved_node !== section_uuid,
              );
            }
          }
          this.project = cleanedProject;
          await this.cleanAndSaveProject();
        }
      }
      this.sendRefresh();
    },
    async deleteAnalysis() {
      let analysisToDelete = this.deepCloneObj(this.checkedAnalysis);
      // If text, delete themes
      if (this.activeTab == 'Text') {
        for (let i = 0; i < analysisToDelete.length; i++) {
          let themeFetchPayload = {
            text_analysis_uuid: analysisToDelete[i].uuid,
          };
          let fetchedThemes = await this.TEXT_SERVICE.fetchTextThemes(themeFetchPayload);
          let fetchedThemeIds = fetchedThemes.map((theme) =>
            theme._id.$oid ? theme._id.$oid : theme._id,
          );
          if (fetchedThemeIds.length) {
            let themeDeletePayload = {
              _ids: fetchedThemeIds,
              text_analysis_uuid: analysisToDelete[i].uuid,
            };
            await this.TEXT_SERVICE.deleteTextThemes(themeDeletePayload);
          }
        }
      }
      // Drop nodes
      for (let i = 0; i < analysisToDelete.length; i++) {
        // Find all matching nodes (this analysis should have saved_nodes_ids). These are found in the slide (report).
        if (analysisToDelete[i].saved_node_ids) {
          for (let a = 0; a < analysisToDelete[i].saved_node_ids.length; a++) {
            for (let b = 0; b < this.reportProjectsAsSlides.length; b++) {
              if (this.reportProjectsAsSlides[b].nodes) {
                for (let c = 0; c < this.reportProjectsAsSlides[b].nodes.length; c++) {
                  // Found a match in a slide between nodes for deletion
                  if (
                    this.reportProjectsAsSlides[b].nodes[c].uuid ==
                    analysisToDelete[i].saved_node_ids[a]
                  ) {
                    let project = await this.$pigeonline.projects.getByID(
                      PigeonDocModel,
                      this.reportProjectsAsSlides[b].id,
                    );
                    if (project && project.nodes) {
                      for (let x = 0; x < project.nodes.length; x++) {
                        if (project.nodes[x].uuid === analysisToDelete[i].saved_node_ids[a]) {
                          project.nodes = project.nodes.filter((item) => item !== project.nodes[x]);
                        }
                        await this.$pigeonline.projects.update(project);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      // Drop from ProjectAnalysis
      for (let i = 0; i < analysisToDelete.length; i++) {
        if (this.activeTab == 'Text') {
          if (this.project.textAnalysisObjects && this.project.textAnalysisObjects.length) {
            const indx = this.project.textAnalysisObjects.findIndex(
              (d) => d.uuid === analysisToDelete[i].uuid,
            );
            this.project.textAnalysisObjects.splice(indx, 1);
          }
        }
        if (this.activeTab == 'Drivers') {
          const indx = this.project.driversAnalysis.findIndex(
            (d) => d.uuid === analysisToDelete[i].uuid,
          );
          this.project.driversAnalysis.splice(indx, 1);
        }
        if (this.activeTab == 'Outliers') {
          const indx = this.project.outliersAnalysis.findIndex(
            (d) => d.uuid === analysisToDelete[i].uuid,
          );
          this.project.outliersAnalysis.splice(indx, 1);
        }
        if (this.activeTab == 'Benchmarking') {
          const indx = this.project.benchmarkAnalysis.findIndex(
            (d) => d.uuid === analysisToDelete[i].uuid,
          );
          this.project.benchmarkAnalysis.splice(indx, 1);
        }
        if (this.activeTab == 'Performance') {
          const indx = this.project.performanceAnalysis.findIndex(
            (d) => d.uuid === analysisToDelete[i].uuid,
          );
          this.project.performanceAnalysis.splice(indx, 1);
        }
      }
      await this.cleanAndSaveProject();
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
    },
    async getReportsFromCollection() {
      let collection;
      if (this.project.collection_id) {
        collection = await this.$pigeonline.projects.getByID(
          PigeonDocCollectionModel,
          this.project.collection_id,
        );
        if (collection) {
          this.thisCollection = collection;
          if (collection.docIds) {
            let project;
            for (let i = 0; i < collection.docIds.length; i++) {
              project = await this.$pigeonline.projects.getByID(
                PigeonDocModel,
                collection.docIds[i],
              );
              if (project) {
                let found = false;
                for (let x = 0; x < this.reportProjectsAsSlides.length; x++) {
                  if (this.reportProjectsAsSlides[x].id === project.id) {
                    this.reportProjectsAsSlides[x] = project;
                    found = true;
                  }
                }
                if (!found) {
                  this.reportProjectsAsSlides.push(project);
                }
              }
            }
          }
        }
      }
    },
    // Prior to 1.10.0, project nodes did not have a reference to the analysis they appear from. This fixes that.
    async assignAnalysisUUIDToSlides() {
      if (this.propReadOnly) {
        return;
      }
      for (let x = 0; x < this.reportProjectsAsSlides.length; x++) {
        if (this.reportProjectsAsSlides[x].nodes) {
          // Check inside nodes for uuid, each node should be assigned a) a slide, and b) have a parent analysis that it came from
          for (let y = 0; y < this.reportProjectsAsSlides[x].nodes.length; y++) {
            if (!this.reportProjectsAsSlides[x].nodes[y].analysis_uuid) {
              // Find the uuid for this analysis by checking all the analysis_objects for 'savedNodes' that matches
              if (this.project.textAnalysisObjects) {
                for (let z = 0; z < this.project.textAnalysisObjects.length; z++) {
                  for (
                    let a = 0;
                    a < this.project.textAnalysisObjects[z].saved_node_ids.length;
                    a++
                  ) {
                    if (
                      this.project.textAnalysisObjects[z].saved_node_ids[a] ==
                      this.reportProjectsAsSlides[x].nodes[y].uuid
                    ) {
                      this.reportProjectsAsSlides[x].nodes[y].analysis_uuid =
                        this.project.textAnalysisObjects[z].uuid;
                    }
                    if (
                      this.project.textAnalysisObjects[z].saved_node_ids[a].uuid &&
                      this.project.textAnalysisObjects[z].saved_node_ids[a].uuid ==
                        this.reportProjectsAsSlides[x].nodes[y].uuid
                    ) {
                      this.reportProjectsAsSlides[x].nodes[y].analysis_uuid =
                        this.project.textAnalysisObjects[z].uuid;
                    }
                  }
                }
              }
              if (this.project.driversAnalysis) {
                for (let z = 0; z < this.project.driversAnalysis.length; z++) {
                  if (this.project.driversAnalysis[z].saved_node_ids) {
                    for (
                      let a = 0;
                      a < this.project.driversAnalysis[z].saved_node_ids.length;
                      a++
                    ) {
                      if (
                        this.project.driversAnalysis[z].saved_node_ids[a] ==
                        this.reportProjectsAsSlides[x].nodes[y].uuid
                      ) {
                        this.reportProjectsAsSlides[x].nodes[y].analysis_uuid =
                          this.project.driversAnalysis[z].uuid;
                      }
                      if (
                        this.project.driversAnalysis[z].saved_node_ids[a].uuid &&
                        this.project.driversAnalysis[z].saved_node_ids[a].uuid ==
                          this.reportProjectsAsSlides[x].nodes[y].uuid
                      ) {
                        this.reportProjectsAsSlides[x].nodes[y].analysis_uuid =
                          this.project.driversAnalysis[z].uuid;
                      }
                    }
                  }
                }
              }
              if (this.project.outliersAnalysis) {
                for (let z = 0; z < this.project.outliersAnalysis.length; z++) {
                  if (this.project.outliersAnalysis[z].saved_node_ids) {
                    for (
                      let a = 0;
                      a < this.project.outliersAnalysis[z].saved_node_ids.length;
                      a++
                    ) {
                      if (
                        this.project.outliersAnalysis[z].saved_node_ids[a] ==
                        this.reportProjectsAsSlides[x].nodes[y].uuid
                      ) {
                        this.reportProjectsAsSlides[x].nodes[y].analysis_uuid =
                          this.project.outliersAnalysis[z].uuid;
                      }
                      if (
                        this.project.outliersAnalysis[z].saved_node_ids[a].uuid &&
                        this.project.outliersAnalysis[z].saved_node_ids[a].uuid ==
                          this.reportProjectsAsSlides[x].nodes[y].uuid
                      ) {
                        this.reportProjectsAsSlides[x].nodes[y].analysis_uuid =
                          this.project.outliersAnalysis[z].uuid;
                      }
                    }
                  }
                }
              }
              if (this.project.benchmarkAnalysis) {
                for (let z = 0; z < this.project.benchmarkAnalysis.length; z++) {
                  if (this.project.benchmarkAnalysis[z].saved_node_ids) {
                    for (
                      let a = 0;
                      a < this.project.benchmarkAnalysis[z].saved_node_ids.length;
                      a++
                    ) {
                      if (
                        this.project.benchmarkAnalysis[z].saved_node_ids[a] ==
                        this.reportProjectsAsSlides[x].nodes[y].uuid
                      ) {
                        this.reportProjectsAsSlides[x].nodes[y].analysis_uuid =
                          this.project.benchmarkAnalysis[z].uuid;
                      }
                      if (
                        this.project.benchmarkAnalysis[z].saved_node_ids[a].uuid &&
                        this.project.benchmarkAnalysis[z].saved_node_ids[a].uuid ==
                          this.reportProjectsAsSlides[x].nodes[y].uuid
                      ) {
                        this.reportProjectsAsSlides[x].nodes[y].analysis_uuid =
                          this.project.benchmarkAnalysis[z].uuid;
                      }
                    }
                  }
                }
              }
              if (this.project.performanceAnalysis) {
                for (let z = 0; z < this.project.performanceAnalysis.length; z++) {
                  if (this.project.performanceAnalysis[z].saved_node_ids) {
                    for (
                      let a = 0;
                      a < this.project.performanceAnalysis[z].saved_node_ids.length;
                      a++
                    ) {
                      if (
                        this.project.performanceAnalysis[z].saved_node_ids[a] ==
                        this.reportProjectsAsSlides[x].nodes[y].uuid
                      ) {
                        this.reportProjectsAsSlides[x].nodes[y].analysis_uuid =
                          this.project.performanceAnalysis[z].uuid;
                      }
                      if (
                        this.project.performanceAnalysis[z].saved_node_ids[a].uuid &&
                        this.project.performanceAnalysis[z].saved_node_ids[a].uuid ==
                          this.reportProjectsAsSlides[x].nodes[y].uuid
                      ) {
                        this.reportProjectsAsSlides[x].nodes[y].analysis_uuid =
                          this.project.performanceAnalysis[z].uuid;
                      }
                    }
                  }
                }
              }
              const new_project = await this.$pigeonline.projects.getByID(
                PigeonDocModel,
                this.reportProjectsAsSlides[x].id,
              );
              if (new_project) {
                new_project.nodes = this.reportProjectsAsSlides[x].nodes;
                await this.$pigeonline.projects.update(new_project);
              }
            }
          }
        }
      }
    },
    async updateCanBeSaved(index) {
      this.canBeSaved = [];
      this.alreadySaved = false;
      const analysis = this.checkedAnalysis;
      if (this.activeTab == 'Text') {
        // for now saving only works for one at a time
        let thisCanBeSaved = await this.canThisTextBeSaved(analysis[0]);
        if (thisCanBeSaved) {
          this.canBeSaved.push(index);
        }
        if (thisCanBeSaved || thisCanBeSaved == 0) {
          this.numberOfThemes = thisCanBeSaved;
        }
      }
      if (this.activeTab == 'Drivers') {
        if (analysis && Object.keys(analysis[0].chart_data).length) {
          this.canBeSaved.push(index);
        }
      }
      if (this.activeTab == 'Outliers') {
        if (analysis[0] && analysis[0].outliers && analysis[0].outliers.length) {
          this.canBeSaved.push(index);
        }
      }
      if (this.activeTab == 'Benchmarking') {
        if (analysis[0] && analysis[0].summary_table && analysis[0].summary_table.length) {
          this.canBeSaved.push(index);
        }
      }
      if (this.activeTab == 'Performance') {
        if (analysis[0] && analysis[0].summary_table && analysis[0].summary_table.length) {
          this.canBeSaved.push(index);
        }
      }
      if (analysis[0].saved_node_ids && analysis[0].saved_node_ids.length) {
        this.alreadySaved = true;

        for (let x = 0; x < this.reportProjectsAsSlides.length; x++) {
          if (this.reportProjectsAsSlides[x].nodes) {
            // Check inside nodes for uuid, each node should be assigned a) a slide, and b) have a parent analysis that it came from
            for (let y = 0; y < this.reportProjectsAsSlides[x].nodes.length; y++) {
              if (
                analysis[0].saved_node_ids.includes(this.reportProjectsAsSlides[x].nodes[y].uuid)
              ) {
                this.selectedSlide = this.reportProjectsAsSlides[x];
                break;
              }
              if (this.reportProjectsAsSlides[x].nodes[y].type == 'section') {
                for (let z = 0; z < this.reportProjectsAsSlides[x].nodes[y].content.length; z++) {
                  if (
                    analysis[0].saved_node_ids.includes(
                      this.reportProjectsAsSlides[x].nodes[y].content[z].uuid,
                    )
                  ) {
                    this.selectedSlide = this.reportProjectsAsSlides[x];
                    break;
                  }
                }
              }
            }
          }
        }
      }
    },
    async canThisTextBeSaved(item) {
      let status = 0;
      if (item.uuid) {
        let payload = {
          text_analysis_uuid: item.uuid,
        };
        const fetchedThemes = await this.TEXT_SERVICE.fetchTextThemes(payload);
        if (fetchedThemes.length) {
          status = fetchedThemes.length;
        }
      }
      return status;
    },
    async setSelectedMode(mode) {
      this.setToUpdatePerformanceMode = [];
      if (mode) {
        if (mode == 'Volumes' || 'Means/averages') {
          this.selectedPerformanceMode = mode;
        }
      } else {
        if (this.checkedAnalysis[0] && this.checkedAnalysis[0].mode) {
          this.selectedPerformanceMode = this.checkedAnalysis[0].mode;
        }
      }
    },
    async setSelectedTimeFilters() {
      this.setToUpdateTimeFilter = [];
      if (this.checkedAnalysis[0] && this.checkedAnalysis[0].time_filter_name) {
        this.selectedTimeFilter = this.checkedAnalysis[0].time_filter_name;
      }
      this.selectedTimeSeries = '';

      if (this.checkedAnalysis[0] && this.checkedAnalysis[0].time_series) {
        this.selectedTimeSeries = this.checkedAnalysis[0].time_series;
      }
    },
    async setSelectedTextQuestion() {
      if (this.checkedAnalysis[0] && this.checkedAnalysis[0].selectedTextQuestion) {
        let question = {};
        await this.updateAllQuestions();
        for (let x = 0; x < this.availableTextQuestions.length; x++) {
          if (
            this.availableTextQuestions[x]._id.$oid ==
            this.checkedAnalysis[0].selectedTextQuestion._id
          ) {
            question = this.availableTextQuestions[x];
            this.selectedTextQuestion = question;
            if (this.checkedAnalysis[0].includeSentiments == 'include') {
              this.selectedTextQuestionIncludesSentiment = true;
            } else if (this.checkedAnalysis[0].includeSentiments == 'exclude') {
              this.selectedTextQuestionIncludesSentiment = false;
            }
            if (this.checkedAnalysis[0].includeSmartCoverage == 'include') {
              this.selectedTextQuestionIncludesSmartCoverage = true;
            } else if (this.checkedAnalysis[0].includeSmartCoverage == 'exclude') {
              this.selectedTextQuestionIncludesSmartCoverage = false;
            }
            if (this.textAIStatus == 'processing') {
              this.startTimer();
            }
          }
        }
      }
    },
    checkDefaultSlideName() {
      for (let x = 0; x < this.reportProjectsAsSlides.length; x++) {
        if (this.newSlideName == this.reportProjectsAsSlides[x].name) {
          var numb = this.newSlideName.match(/\d/g);
          numb = numb.join('');
          this.newSlideName = 'Slide ' + (Number(numb) + 1);
        }
      }
    },
    setFirstOptionInSlides() {
      if (this.reportProjectsAsSlides && this.reportProjectsAsSlides.length) {
        this.slideForSaving = this.reportProjectsAsSlides[0];
      }
    },
    async saveAnalysis(new_slide) {
      if (new_slide == true) {
        this.slideForSaving = {};
      }
      // Child Analyses handle the saving. They can see the name of the new slide (if creating a new one) or the selected slide. When the index activates in their props, they start the saving with this information.
      const analysisToSave = this.deepCloneObj(this.checkedAnalysis);
      this.setToSave = [];
      this.setToSave.push(analysisToSave[0].uuid);
      setTimeout(() => {
        this.setToSave = [];
      }, 200);
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.showSaveOptions = [];
    },
    toggleSort() {
      if (this.sortBy === 'new') {
        this.sortBy = 'old';
      } else {
        this.sortBy = 'new';
      }
    },
    addToShowAnalysisCheckOptions(checked_analysis) {
      this.showExtraOptions = [];
      if (this.activeTab == 'Text') {
        this.selectedTextQuestion = {};
        this.stopTimer();
      }
      let checkedAnalysis = this.deepCloneObj(this.checkedAnalysis);
      let checkedAnalysisFilter = [];
      checkedAnalysisFilter = checkedAnalysis.filter(
        (analysis) => analysis.uuid == checked_analysis.uuid,
      );
      if (checkedAnalysisFilter.length) {
        this.checkedAnalysis = checkedAnalysis.filter(
          (analysis) => analysis.uuid != checked_analysis.uuid,
        );
      } else {
        this.checkedAnalysis.push(checked_analysis);
      }
      let showAnalysisCheckOptions = this.deepCloneObj(this.showAnalysisCheckOptions);
      let opennedOption = [];
      opennedOption = showAnalysisCheckOptions.filter((item) => item.uuid == checked_analysis.uuid);
      if (opennedOption.length) {
        this.showAnalysisCheckOptions = showAnalysisCheckOptions.filter(
          (item) => item.uuid != checked_analysis.uuid,
        );
      } else {
        this.showAnalysisCheckOptions.push(checked_analysis);
      }
    },
    sendRefresh() {
      if (this.$refs.DocManagerRef) {
        this.$refs.DocManagerRef.refresh();
      }
      this.$emit('updateSlides');
    },
    changeTabMode(mode) {
      if (mode) {
        this.tabMode = mode;
      }
    },
    async updateAllQuestions() {
      this.availableQuestions = [];
      this.availableTextQuestions = [];
      if (this.project) {
        if (this.project.datasets) {
          if (this.project.datasets.length) {
            const theseQuestions = await this.fetchClientQuestions(this.project.datasets[0]);
            if (theseQuestions) {
              for (let i = 0; i < theseQuestions.length; i++) {
                this.availableQuestions.push(theseQuestions[i]);
                if (theseQuestions[i].approved_data_type == 'OPEN_ENDED') {
                  this.availableTextQuestions.push(theseQuestions[i]);
                }
              }
            }
          }
        }
      }
      if (this.availableQuestions && this.availableQuestions.length)
        this.performanceQuestions = this.availableQuestions.filter(
          (el) =>
            el.approved_data_type &&
            (el.approved_data_type.match(/(SCALE_\d+_TO_\d+)+/) ||
              el.approved_data_type.match('CAT')),
        );
    },
    // Text analysis
    async autoSuggestedTextAnalysis() {
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.selectedTextQuestion = {};
      this.stopTimer();
      if (this.dataset._id.$oid) {
        if (this.availableTextQuestions.length) {
          await this.getSuggestedTextQuestion();
          if (this.suggestedQuestionForAnalysis) {
            //this.createFirstAnalysis(this.suggestedQuestionForAnalysis)
            let questionId = this.suggestedQuestionForAnalysis._id;
            if (this.suggestedQuestionForAnalysis._id.$oid) {
              questionId = this.suggestedQuestionForAnalysis._id.$oid;
            }
            this.parseAndCreateFirstTextAnalysis(questionId);
          }
        }
      }
    },
    getSuggestedTextQuestion() {
      let largestCount = 0;
      let largestID = 0;
      if (this.availableTextQuestions.length > 1) {
        let count;
        for (let i = 0; i < this.availableTextQuestions.length; i++) {
          count = 0;
          for (let x = 0; x < this.availableTextQuestions[i].unique_values.length; x++) {
            if (this.availableTextQuestions[i].unique_values[x].is_valid === true) {
              count = count + 1;
            }
          }
          if (count > largestCount) {
            largestCount = count;
            largestID = i;
          }
        }
      }
      this.suggestedQuestionForAnalysis = this.availableTextQuestions[largestID];
    },
    async addNewTextAnalysis() {
      this.isNewTextModalVisible = true;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
      this.selectedTextQuestion = {};
      this.stopTimer();
    },
    async addNewDriversAnalysis() {
      this.isNewDriversModalVisible = true;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
    },
    async parseAndCreateFirstTextAnalysis(questionId, filterParam) {
      let newObject = {};
      if (this.availableTextQuestions.length) {
        for (let i = 0; i < this.availableTextQuestions.length; i++) {
          // oid preserved for availabletextquestions because it's saved directly in frontend but not used in the backend
          if (this.availableTextQuestions[i]._id) {
            if (this.availableTextQuestions[i]._id.$oid) {
              if (this.availableTextQuestions[i]._id.$oid === questionId) {
                newObject = this.availableTextQuestions[i];
                newObject._id = '';
                newObject._id = questionId;
                this.createFirstTextAnalysis(newObject, filterParam);
              }
            } else if (this.availableTextQuestions[i]._id === questionId) {
              newObject = this.availableTextQuestions[i];
              newObject._id = '';
              newObject._id = questionId;
              this.createFirstTextAnalysis(newObject, filterParam);
            }
          }
        }
      }
    },
    async createFirstTextAnalysis(question, filterParam) {
      let textTitle = '';
      if (!question.analysis_title || !question.analysis_title.length) {
        if (question.question_title.length) {
          textTitle = question.question_title;
        }
        if (question.question_title.length && question.question_text.length) {
          textTitle += ' - ';
        }
        if (question.question_text.length) {
          textTitle += question.question_text;
        }
      }
      // Create empty object which we will fill before saving
      const emptyTextAnalysis = this.deepCloneObj(await this.fetchEmptyTextAnalysis());
      if (question && question.unique_values) {
        question.unique_values = [];
      }
      emptyTextAnalysis.datasetId = this.dataset._id.$oid;
      emptyTextAnalysis.uuid = await this.$pigeonline.createUUID();
      emptyTextAnalysis.selectedTextQuestion = question;
      emptyTextAnalysis.filterParams = filterParam;
      emptyTextAnalysis.last_modified_on = moment().valueOf();
      emptyTextAnalysis.analysis_title = textTitle;
      // convert to format that can be read by the backend for quick saving
      if (question._id) {
        if (question._id.$oid) {
          emptyTextAnalysis.selectedTextQuestion._id = question._id.$oid;
        }
      }
      this.project.textAnalysisObjects.unshift(emptyTextAnalysis);
    },
    fetchAIPreprocessing(analysis) {
      if (analysis) {
        this.fetchTheseAIPreprocessing.push(analysis);
      }
    },
    // Drivers
    onClickAddNewDrivers() {
      this.isNewDriversModalVisible = true;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
    },
    async findSuggestedDriversVariables() {
      this.findingSuggestedDriversVariables = true;
      this.suggestedDriversVariables = await this.fetchSuggestedDriversVariables();
      // returned an error, no drivers automatically found
      if ([406, 424].includes(this.suggestedDriversVariables)) {
        this.statusNoAutoDriversFound = true;
      } else {
        this.useSuggestedDriversVariables();
      }
      this.findingSuggestedDriversVariables = false;
    },
    async fetchSuggestedDriversVariables() {
      try {
        const datasetId = this.$store.getters['datasetDetails/getDataset']._id.$oid;
        const response = await this.$services.DRIVERS_SERVICE.suggestedVariables({
          data_set_id: datasetId,
        });
        return response;
      } catch (e) {
        throw new Error('ProjectAnalysisDrivers:fetchSuggestedDriversVariables' + e.message);
      }
    },
    useSuggestedDriversVariables() {
      this.createNewDrivers(
        [this.suggestedDriversVariables.dependent_variable_id],
        this.suggestedDriversVariables.independent_variables_ids,
      );
    },
    createNewDrivers(dependent, independent, filterParam) {
      let dependentVariableTitle = this.$_driversAnalysisMixin_getDependentVarTitle(dependent);
      let driversTitle = 'Predicting ' + dependentVariableTitle;
      const driversObject = {
        saved_performance_type: this.projectPerformanceType || 'scale-average',
        dependent_variable_id: dependent,
        dependent_variable_title: dependentVariableTitle,
        independent_variables_ids: independent,
        last_modified_on: moment().valueOf(),
        uuid: this.$pigeonline.createUUID(),
        filter_params: filterParam || {},
        analysis_title: driversTitle,
        time_filter_name: 'All',
        time_series: 'None',
      };
      if (this.project.driversAnalysis == null) {
        this.project.driversAnalysis = [];
        this.project.driversAnalysis.push(driversObject);
      } else {
        this.project.driversAnalysis.unshift(driversObject);
      }
    },
    // Outliers
    async findSuggestedOutliersVariables() {
      this.suggestedOutliersVariables = await this.fetchSuggestedOutliersVariables();
      this.suggestedOutliersVariables = this.suggestedOutliersVariables.map(
        (variable) => variable[0],
      );
      this.createNewOutliers(this.suggestedOutliersVariables);
    },
    async fetchSuggestedOutliersVariables() {
      let foundVars = [];
      if (this.clientQuestions && this.clientQuestions.length) {
        for (let i = 0; i < this.clientQuestions.length; i++) {
          if (
            this.clientQuestions[i].approved_data_type &&
            this.clientQuestions[i].approved_data_type.includes('SCALE')
          ) {
            foundVars.push(this.clientQuestions[i]);
          }
        }
      }
      return foundVars.map((el) => [el._id.$oid, el.question_title]);
    },
    addNewOutliersAnalysis() {
      this.isNewOutliersModalVisible = true;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
    },
    async createNewOutliers(selectedQuestions, filterParam) {
      let outlierTitle = '';
      if (selectedQuestions.length) {
        outlierTitle = 'Across ' + selectedQuestions.length;
        if (selectedQuestions.length == 1) {
          outlierTitle = outlierTitle + ' scale question';
        } else {
          outlierTitle = outlierTitle + ' scale questions';
        }
      }
      if (this.project.outliersAnalysis) {
        const outliersObject = {
          last_modified_on: moment().valueOf(),
          uuid: this.$pigeonline.createUUID(),
          filter_params: filterParam || {},
          summary_table: [],
          outliers: [],
          selectedQuestions: selectedQuestions,
          analysis_title: outlierTitle,
        };
        this.project.outliersAnalysis.unshift(outliersObject);

        const response = await this.OUTLIERS_SERVICE.outliersAnalysis({
          data_set_id: this.project.datasets[0],
          client_questions_ids: outliersObject.selectedQuestions,
        });
        if (response) {
          if (response.data.summary_table) {
            if (!(response.data.summary_table instanceof Array)) {
              if (typeof response.data.summary_table !== 'object') {
                response.data.summary_table = [];
              } else {
                response.data.summary_table = Object.entries(response.data.summary_table);
              }
            }
            outliersObject.summary_table = response.data.summary_table;
            for (let i = 0; i < this.project.outliersAnalysis.length; i++) {
              if (this.project.outliersAnalysis[i].uuid === outliersObject.uuid) {
                this.project.outliersAnalysis[i].summary_table = response.data.summary_table;
                this.project.outliersAnalysis[i].last_modified_on = moment().valueOf();
              }
            }
            await this.cleanAndSaveProject();
          }
        }
      }
    },
    // Benchmarking
    async createNewBMs(selectedQuestions, filterParam) {
      this.getbenchmarkAnalysisObjects(filterParam, selectedQuestions);
    },
    async getbenchmarkAnalysisObjects(filter_param, subsetOfQuestions) {
      this.findingSuggestedBenchmarkingVariables = true;
      //this.savedPerformanceType = this.projectPerformanceType || "scale-average"
      const summaryResults = await this.fetchSummaryResults(
        this.project.id,
        filter_param,
        subsetOfQuestions,
      );
      if (summaryResults) {
        summaryResults.uuid = this.$pigeonline.createUUID();
        // no summary results because there are no 5point scales that are matched to benchmark quesitons
        if (!summaryResults) this.statusNoScaleMatches = true;
        // Are we still using this store function?
        this.$store.dispatch('project/setBenchmarkSummaryResults', summaryResults);
        if (filter_param) {
          summaryResults.filter_param = filter_param;
        } else {
          summaryResults.filter_param = {};
        }
        await this.saveBMResultsToProject(summaryResults);
        this.findingSuggestedBenchmarkingVariables = false;
      } else {
        this.noResults = true;
      }
    },
    async getDatasetStatus() {
      const response = await this.$pigeonline.projects.get(BenchmarkingDataset, {
        dataset_id: this.dataset._id.$oid,
      });
      this.benchmarksApproved = response[0].status.benchmarksApproved;

      if (!this.benchmarksApproved) {
        this.numNotApprovedBenchmarks = this.benchmarks.filter((b) => !b.approved).length;
        this.numTotalBenchmarks = this.benchmarks.length;
      }
    },
    addAutoBenchmarkingAnalysis() {
      this.getbenchmarkAnalysisObjects();
    },
    addBenchmarkingAnalysis() {
      this.isNewBMModalVisible = true;
    },
    async saveBMResultsToProject(summaryResults) {
      let benchmarkTitle = 'Comparison to peers';
      if (summaryResults.benchmarking_group_name && summaryResults.benchmarking_group_name.length) {
        benchmarkTitle = 'Comparison to ' + summaryResults.benchmarking_group_name;
      }
      summaryResults.last_modified_on = moment().valueOf();
      summaryResults.analysis_title = benchmarkTitle;
      this.project.benchmarkAnalysis.push(summaryResults);
      this.project.settings.autogeneratedBenchmarks = true;
      await this.cleanAndSaveProject();
      // await this.saveProject(this.project)
    },
    // Performance
    showCreatePerformanceModal() {
      this.isCreatePerformanceModalVisible = true;
      this.showAnalysisCheckOptions = [];
      this.selectedBoxes = [];
      this.checkedAnalysis = [];
    },
    closePerformanceModal() {
      this.isCreatePerformanceModalVisible = false;
    },
    async createNewPerformance(selectedQuestions, filterParam, segmentParam) {
      if (this.project) {
        if (this.project.datasets) {
          if (this.project.datasets.length) {
            // this.project.performanceAnalysis.unshift(performanceObject)
            this.generatePerformanceAnalysis(selectedQuestions, filterParam, segmentParam);
          }
        }
      }
    },
    async generatePerformanceAnalysis(selectedQuestions, filterParam, segmentParam) {
      this.closePerformanceModal();
      this.error = false;
      if (this.project && Object.keys(this.project).length) {
        try {
          // add new performance placeholder
          // isLongWait shows "analysis may take a minute" warning
          // true if exceed THRESHOLD or if APi takes more than 30 seconds

          let performanceTitle = '';
          let question_type_label = ' scale';
          let question_text = '';
          let is_cat = false;
          for (let i = 0; i < selectedQuestions.length; i++) {
            let this_question = this.availableQuestions.filter(
              (question) => question._id.$oid == selectedQuestions[i][0],
            );
            if (
              this_question[0].approved_data_type &&
              this_question[0].approved_data_type == 'CAT'
            ) {
              is_cat = true;
              question_type_label = ' categorical';
            }
            question_text = this_question[0].question_title;
            if (this_question[0].question_text) {
              question_text = this_question[0].question_text;
            }
          }
          let mode = 'Means/averages';
          let mode_description = 'Performance across ';
          if (is_cat == true) {
            mode = 'Volumes';
            mode_description = 'Volumes across ';
          }
          if (selectedQuestions.length > 1) {
            performanceTitle =
              mode_description + selectedQuestions.length + question_type_label + ' questions';
          } else {
            performanceTitle = mode_description + question_text;
          }
          let placeholder = {
            uuid: this.$pigeonline.createUUID(),
            last_modified_on: moment().valueOf(),
            filter_params: filterParam || {},
            selectedQuestions: selectedQuestions,
            isCancelled: false,
            isFetching: true,
            isLongWait: false,
            segmentedBy: segmentParam,
            sortedBy: 'Original',
            summary_table: [],
            threshold: -1,
            analysis_title: performanceTitle,
            mode: mode,
          };
          let running = true;

          // show the empty loading wrapper
          this.project.performanceAnalysis.unshift(placeholder);

          // after 30 seconds if fetch is still in progress, show warning
          setTimeout(() => {
            if (running) {
              placeholder.isLongWait = true;
            }
          }, 30000);
          // fetch performance analysis data
          const response = await this.$_performanceAnalysisMixin_fetchAnalysis(
            this.dataset._id.$oid,
            selectedQuestions.map((el) => el[0]), // el: [id, question_title]
            segmentParam, // segments
            placeholder.filter_params,
            placeholder.uuid,
          );
          running = false;
          if (response && typeof response === 'object') {
            response.summary_table = Object.entries(response.summary_table);
            const indx = this.project.performanceAnalysis.findIndex(
              (a) => a.uuid === placeholder.uuid,
            );
            Object.assign(this.project.performanceAnalysis[indx], response, {
              isFetching: false,
              isLongWait: false,
              summary_table: response.summary_table,
            });
            this.project.performanceAnalysis[indx].chart_insights = [];
            this.retrievedSummaryTable = this.project.performanceAnalysis[indx].summary_table;

            await this.cleanAndSaveProject();
          } else {
            throw new Error('Invalid performance response.');
          }
        } catch (e) {
          if (e.code == 499) {
            this.cancelPerformanceAnalysis(e.uuid);
          } else {
            // cleanup
            this.project.performanceAnalysis.shift();
            this.error = true;
            throw new Error(
              'ProjectAnalysisPerformance:generatePerformanceAnalysis:: ' + e.message,
            );
          }
        }
      }
    },
    cancelPerformanceAnalysis(uuid) {
      if (this.project) {
        let analysis = this.project.performanceAnalysis.find((a) => a.uuid === uuid);
        if (analysis) {
          analysis.isCancelled = true;
          analysis.isFetching = false;
          analysis.isLongWait = false;
          //this.saveProject(this.project)
        }
      }
    },
    async findSuggestedPerformanceVariables() {
      this.findingSuggestedPerformanceVariables = true;

      this.suggestedPerformanceVariables = await this.fetchSuggestedPerformanceVariables();
      if (this.suggestedPerformanceVariables.length) {
        this.createNewPerformance(this.suggestedPerformanceVariables);
      }
      this.findingSuggestedPerformanceVariables = false;
    },
    async fetchSuggestedPerformanceVariables() {
      let foundVars = [];
      if (this.clientQuestions && this.clientQuestions.length) {
        for (let i = 0; i < this.clientQuestions.length; i++) {
          if (
            this.clientQuestions[i].approved_data_type &&
            this.clientQuestions[i].approved_data_type.includes('SCALE')
          ) {
            foundVars.push(this.clientQuestions[i]);
          }
        }
      }
      return foundVars.map((el) => [el._id.$oid, el.question_title]);
    },
  },
};
</script>
